import * as React from "react";
import { SVGProps } from "react";

const SuccessIllustration = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={304}
        height={304}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M249.663 159.235c-54.381-31.4-142.266-31.4-196.297 0-54.032 31.399-53.744 82.339.637 113.701 54.381 31.363 142.272 31.4 196.303 0 54.032-31.399 53.744-82.302-.643-113.701Z"
            fill="#F5F5F5"
        />
        <path
            d="M63.208 190.235c-4.097-2.361-10.717-2.361-14.788 0-4.072 2.36-4.047 6.201.05 8.568 4.096 2.366 10.716 2.36 14.781 0 4.066-2.361 4.047-6.202-.043-8.568ZM67.823 243.904c13.476-7.782 35.252-7.782 48.635 0 13.383 7.781 13.321 20.396-.156 28.177-13.477 7.781-35.253 7.781-48.642 0-13.389-7.781-13.314-20.396.163-28.177ZM264.607 239.632c-4.096-2.361-10.716-2.361-14.782 0-4.065 2.361-4.046 6.201.05 8.568 4.097 2.367 10.71 2.361 14.782 0 4.072-2.36 4.047-6.201-.05-8.568Z"
            fill="#E6E6E6"
        />
        <path
            d="m172.507 81.373 7.656-4.422-.006-2.635-7.657 4.421.007 2.636ZM172.482 73.06l7.656-4.42-.006-2.661-7.656 4.421.006 2.66Z"
            fill="#FAFAFA"
        />
        <path
            d="m172.481 73.06.019 5.677 7.656-4.421-.018-5.677-7.657 4.422Z"
            fill="#E6E6E6"
        />
        <path
            d="m172.482 73.06-.007-2.66-4.165-2.423.006 2.667 4.159 2.417h.007ZM172.475 78.75l-4.14-2.41.006 2.61 4.166 2.423-.007-2.636-.025.013Z"
            fill="#EBEBEB"
        />
        <path
            d="m172.501 78.737-.019-5.676h-.006l-4.16-2.417.019 5.695 4.141 2.41.025-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m180.132 65.979-4.166-2.423-7.656 4.421 4.165 2.423 7.657-4.421Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m180.157 74.316-.019-5.677-.006-2.66-4.166-2.423-7.656 4.421.006 2.667.019 5.695.006 2.61 4.166 2.424 7.656-4.422-.006-2.635Z"
            fill="#000"
        />
        <path
            d="m240.096 106.071-10.617-6.126-.019 6.726 10.617 6.132.019-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m240.077 112.803-10.617-6.132-.006.781 10.617 6.132.006-.781Z"
            fill="#fff"
        />
        <path
            d="m240.071 113.584-10.617-6.133v1.006l10.617 6.132v-1.005Z"
            fill="#E6E6E6"
        />
        <path
            d="m240.071 114.589-10.617-6.132-.006.781 10.623 6.132v-.781Z"
            fill="#fff"
        />
        <path
            d="m240.108 102.118-10.623-6.132v1.392l10.617 6.127.006-1.387Z"
            fill="#E6E6E6"
        />
        <path
            d="m240.095 105.297-10.616-6.132v.78l10.616 6.126v-.774ZM240.102 103.505l-10.617-6.127-.006.775 10.623 6.132v-.78Z"
            fill="#fff"
        />
        <path
            d="m240.102 104.285-10.623-6.132v1.011l10.616 6.133.007-1.012ZM229.448 109.238v1.211l10.617 6.133.006-1.212-10.623-6.132Z"
            fill="#E6E6E6"
        />
        <path
            d="m240.108 104.292-.006-.007-.006 1.012h.012l3.891-2.261v-1.011l-3.891 2.267ZM240.102 103.505l.006.006 3.897-2.267v-1.393l-3.897 2.267-.006 1.387Z"
            fill="#E0E0E0"
        />
        <path
            d="M240.102 103.505v.78l.006.007 3.891-2.267.006-.781-3.897 2.267-.006-.006ZM240.096 105.297v.774l.012.007 3.891-2.261v-.781l-3.891 2.261h-.012ZM240.077 112.803l-.006.781.037.019 3.866-2.248.006-.781-3.872 2.248-.031-.019ZM240.071 115.37l-.007 1.212 3.904-2.267v-1.168l-3.86 2.242-.037-.019Z"
            fill="#E0E0E0"
        />
        <path
            d="M240.071 114.589v.781l.037.019 3.86-2.242.006-.781-3.866 2.242-.037-.019Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="M240.102 103.505v.78l.006.007 3.891-2.267.006-.781-3.897 2.267-.006-.006ZM240.096 105.297v.774l.012.007 3.891-2.261v-.781l-3.891 2.261h-.012ZM240.077 112.803l-.006.781.037.019 3.866-2.248.006-.781-3.872 2.248-.031-.019ZM240.071 114.589v.781l.037.019 3.86-2.242.006-.781-3.866 2.242-.037-.019Z"
            fill="#000"
        />
        <path
            d="M240.071 113.584v1.005l.037.019 3.866-2.242v-1.011l-3.866 2.248-.037-.019ZM240.096 106.071l-.019 6.732.031.019 3.872-2.248.019-6.757-3.891 2.261-.012-.007Z"
            fill="#E0E0E0"
        />
        <path
            d="m244.005 99.851-10.617-6.132-3.903 2.267 10.623 6.132 3.897-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m233.389 93.719-3.903 2.267v1.392l-.007.775V99.945l-.018 6.726-.007.78v1.006l-.006.781v1.211l10.617 6.133 3.903-2.267v-1.168l.006-.781v-1.011l.006-.781.019-6.757V102.025l.006-.781v-1.393l-10.616-6.132Z"
            fill="#000"
        />
        <path
            d="M234.762 104.285c2.092 1.206 3.791 3.123 3.791 4.278 0 1.155-1.711 1.112-3.803-.1-2.092-1.211-3.791-3.122-3.785-4.278.007-1.155 1.705-1.111 3.797.1Z"
            fill="#fff"
        />
        <path
            d="m233.607 109.981-10.616-6.133-.019 6.732 10.617 6.133.018-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m233.589 116.713-10.617-6.133v.781l10.617 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m233.588 117.487-10.616-6.126-.006 1.005 10.616 6.133.006-1.012Z"
            fill="#E6E6E6"
        />
        <path
            d="m233.582 118.499-10.616-6.133v.781l10.616 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m233.62 106.021-10.617-6.126-.006 1.386 10.616 6.133.007-1.393Z"
            fill="#E6E6E6"
        />
        <path
            d="m233.613 109.2-10.622-6.132v.78l10.616 6.133.006-.781ZM233.613 107.414l-10.616-6.133v.781l10.616 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m233.613 108.188-10.616-6.126-.006 1.006 10.622 6.132v-1.012ZM222.966 113.147l-.007 1.211 10.617 6.127.006-1.212-10.616-6.126Z"
            fill="#E6E6E6"
        />
        <path
            d="m233.62 108.195-.007-.007v1.012l.007.006 3.89-2.26.006-1.012-3.896 2.261ZM233.613 107.414h.007l3.896-2.261.007-1.399-3.903 2.267-.007 1.393Z"
            fill="#E0E0E0"
        />
        <path
            d="M233.613 107.414v.774l.007.007 3.896-2.261v-.781l-3.896 2.261h-.007ZM233.613 109.2l-.006.781.012.006 3.891-2.261v-.78l-3.891 2.26-.006-.006ZM233.588 116.713v.774l.032.019 3.871-2.248v-.781l-3.871 2.248-.032-.012ZM233.582 119.273l-.006 1.212 3.903-2.267.006-1.168-3.866 2.248-.037-.025Z"
            fill="#E0E0E0"
        />
        <path
            d="M233.582 118.499v.774l.037.025 3.866-2.248v-.781l-3.866 2.249-.037-.019Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="M233.613 107.414v.774l.007.007 3.896-2.261v-.781l-3.896 2.261h-.007ZM233.613 109.2l-.006.781.012.006 3.891-2.261v-.78l-3.891 2.26-.006-.006ZM233.588 116.713v.774l.032.019 3.871-2.248v-.781l-3.871 2.248-.032-.012ZM233.582 118.499v.774l.037.025 3.866-2.248v-.781l-3.866 2.249-.037-.019Z"
            fill="#000"
        />
        <path
            d="m233.588 117.487-.006 1.012.037.019 3.866-2.249.006-1.011-3.872 2.248-.031-.019ZM233.607 109.981l-.019 6.732.032.012 3.871-2.248.019-6.751-3.89 2.261-.013-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="M237.523 103.754 226.9 97.628l-3.897 2.267 10.617 6.126 3.903-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m226.9 97.628-3.897 2.267-.006 1.386v.781l-.006 1.006v.78l-.019 6.732v.781l-.006 1.005v.781l-.007 1.211 10.617 6.127 3.903-2.267.006-1.168v-.781l.006-1.011v-.781l.019-6.751v-.78l.006-1.012v-.781l.007-1.399-10.623-6.126Z"
            fill="#000"
        />
        <path
            d="M228.28 108.188c2.092 1.212 3.791 3.123 3.785 4.278-.007 1.156-1.705 1.112-3.797-.093-2.092-1.206-3.791-3.123-3.791-4.285 0-1.161 1.705-1.111 3.803.1Z"
            fill="#fff"
        />
        <path
            d="m227.125 113.884-10.617-6.127-.025 6.726 10.623 6.133.019-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m227.106 120.616-10.623-6.133v.781l10.617 6.132.006-.78Z"
            fill="#fff"
        />
        <path
            d="m227.1 121.396-10.617-6.132v1.005l10.617 6.133v-1.006Z"
            fill="#E6E6E6"
        />
        <path
            d="m227.1 122.402-10.617-6.133-.006.781 10.623 6.133v-.781Z"
            fill="#fff"
        />
        <path
            d="m227.137 109.931-10.622-6.133v1.393l10.616 6.126.006-1.386Z"
            fill="#E6E6E6"
        />
        <path
            d="m227.125 113.103-10.617-6.126v.781l10.617 6.126v-.781ZM227.131 111.317l-10.616-6.126-.007.774 10.623 6.133v-.781Z"
            fill="#fff"
        />
        <path
            d="m227.131 112.098-10.623-6.133v1.012l10.617 6.126.006-1.005ZM216.477 117.05v1.211l10.616 6.133.007-1.211-10.623-6.133Z"
            fill="#E6E6E6"
        />
        <path
            d="m227.137 112.104-.006-.006-.006 1.005.012.006 3.891-2.26v-1.012l-3.891 2.267ZM227.131 111.317l.007.006 3.896-2.267v-1.392l-3.896 2.267-.007 1.386Z"
            fill="#E0E0E0"
        />
        <path
            d="M227.131 111.317v.781l.007.006 3.89-2.267.006-.781-3.896 2.267-.007-.006ZM227.125 113.103v.781l.012.006 3.891-2.261v-.78l-3.891 2.26-.012-.006ZM227.106 120.616l-.006.78.038.019 3.865-2.248v-.781l-3.865 2.249-.032-.019ZM227.1 123.183l-.006 1.211 3.903-2.267v-1.168l-3.86 2.242-.037-.018Z"
            fill="#E0E0E0"
        />
        <path
            d="M227.1 122.402v.781l.038.018 3.859-2.242.006-.78-3.865 2.242-.038-.019Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="M227.131 111.317v.781l.007.006 3.89-2.267.006-.781-3.896 2.267-.007-.006ZM227.125 113.103v.781l.012.006 3.891-2.261v-.78l-3.891 2.26-.012-.006ZM227.106 120.616l-.006.78.038.019 3.865-2.248v-.781l-3.865 2.249-.032-.019ZM227.1 122.402v.781l.038.018 3.859-2.242.006-.78-3.865 2.242-.038-.019Z"
            fill="#000"
        />
        <path
            d="M227.1 121.396v1.006l.038.019 3.865-2.242v-1.012l-3.865 2.248-.038-.019ZM227.125 113.884l-.019 6.732.031.019 3.866-2.249.025-6.757-3.891 2.261-.012-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="m231.034 107.664-10.616-6.133-3.903 2.267 10.622 6.133 3.897-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m220.418 101.531-3.903 2.267v1.393l-.007.774V107.758l-.025 6.725v1.786l-.006.781v1.211l10.616 6.133 3.904-2.267v-1.168l.006-.78V118.386l.025-6.757v-1.792l.006-.781v-1.392l-10.616-6.133Z"
            fill="#000"
        />
        <path
            d="M221.779 112.092c2.092 1.211 3.791 3.122 3.791 4.284 0 1.161-1.711 1.105-3.803-.1-2.092-1.206-3.791-3.123-3.785-4.278.007-1.155 1.718-1.112 3.797.094Z"
            fill="#fff"
        />
        <path
            d="m257.038 115.963-10.622-6.126-.019 6.726 10.623 6.132.018-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m257.02 122.695-10.623-6.132v.781l10.616 6.132.007-.781Z"
            fill="#fff"
        />
        <path
            d="m257.013 123.476-10.616-6.133v1.012l10.616 6.126v-1.005Z"
            fill="#E6E6E6"
        />
        <path
            d="m257.013 124.481-10.616-6.126-.006.775 10.622 6.132v-.781Z"
            fill="#fff"
        />
        <path
            d="m257.051 112.01-10.623-6.126v1.386l10.617 6.133.006-1.393Z"
            fill="#E6E6E6"
        />
        <path
            d="m257.038 115.189-10.616-6.133-.006.781 10.622 6.126v-.774ZM257.045 113.403l-10.617-6.133-.006.781 10.616 6.126.007-.774Z"
            fill="#fff"
        />
        <path
            d="m257.038 114.177-10.616-6.126v1.005l10.616 6.133v-1.012ZM246.391 119.13v1.211l10.616 6.133.006-1.212-10.622-6.132Z"
            fill="#E6E6E6"
        />
        <path
            d="m257.051 114.184-.013-.007v1.012l.013.006 3.89-2.267v-1.011l-3.89 2.267ZM257.044 113.403h.007l3.897-2.267v-1.393l-3.897 2.267-.007 1.393Z"
            fill="#E0E0E0"
        />
        <path
            d="m257.044 113.403-.006.774.013.007 3.89-2.267.006-.781-3.896 2.267h-.007ZM257.038 115.189v.774l.013.007 3.884-2.261.006-.781-3.89 2.267-.013-.006ZM257.019 122.695l-.006.781.038.019 3.865-2.248v-.781l-3.865 2.248-.032-.019ZM257.013 125.262l-.006 1.212 3.903-2.267v-1.168l-3.859 2.242-.038-.019Z"
            fill="#E0E0E0"
        />
        <path
            d="M257.013 124.481v.781l.038.019 3.859-2.242.006-.781-3.865 2.248-.038-.025Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m257.044 113.403-.006.774.013.007 3.89-2.267.006-.781-3.896 2.267h-.007ZM257.038 115.189v.774l.013.007 3.884-2.261.006-.781-3.89 2.267-.013-.006ZM257.019 122.695l-.006.781.038.019 3.865-2.248v-.781l-3.865 2.248-.032-.019ZM257.013 124.481v.781l.038.019 3.859-2.242.006-.781-3.865 2.248-.038-.025Z"
            fill="#000"
        />
        <path
            d="M257.013 123.476v1.005l.038.025 3.865-2.248v-1.011l-3.865 2.248-.038-.019ZM257.038 115.963l-.018 6.732.031.019 3.865-2.248.019-6.757-3.884 2.261-.013-.007Z"
            fill="#E0E0E0"
        />
        <path
            d="m260.948 109.743-10.617-6.126-3.903 2.267 10.623 6.126 3.897-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m250.331 103.617-3.903 2.267v1.386l-.006.781v1.005l-.006.781-.019 6.726V118.355l-.006.775v1.211l10.616 6.133 3.903-2.267v-1.168l.006-.781V120.466l.019-6.757.006-.781v-1.011l.007-.781v-1.393l-10.617-6.126Z"
            fill="#000"
        />
        <path
            d="M251.705 114.177c2.092 1.206 3.791 3.123 3.785 4.278-.007 1.155-1.705 1.112-3.797-.1-2.092-1.211-3.791-3.122-3.785-4.278.006-1.155 1.705-1.111 3.797.1Z"
            fill="#fff"
        />
        <path
            d="m250.55 119.873-10.617-6.133-.018 6.732 10.616 6.133.019-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m250.531 126.605-10.616-6.133v.781l10.616 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m250.531 127.379-10.617-6.126-.006 1.005 10.617 6.133.006-1.012Z"
            fill="#E6E6E6"
        />
        <path
            d="m250.525 128.391-10.617-6.133v.781l10.617 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m250.562 115.92-10.616-6.133-.007 1.386 10.617 6.133.006-1.386Z"
            fill="#E6E6E6"
        />
        <path
            d="m250.55 119.092-10.617-6.126v.774l10.617 6.133v-.781ZM250.556 117.306l-10.617-6.133v.781l10.617 6.133v-.781Z"
            fill="#fff"
        />
        <path
            d="m250.556 118.087-10.617-6.133-.006 1.012 10.617 6.126.006-1.005ZM239.908 123.039l-.006 1.211 10.616 6.127.007-1.212-10.617-6.126Z"
            fill="#E6E6E6"
        />
        <path
            d="M250.562 118.087h-.006l-.006 1.005.012.006 3.891-2.26.006-1.012-3.897 2.261ZM250.556 117.306h.006l3.897-2.261.006-1.392-3.903 2.267-.006 1.386Z"
            fill="#E0E0E0"
        />
        <path
            d="M250.556 117.306v.781h.006l3.897-2.261v-.781l-3.897 2.261h-.006ZM250.55 119.092v.781l.012.006 3.891-2.261v-.78l-3.891 2.26-.012-.006ZM250.531 126.605v.774l.031.019 3.872-2.248v-.781l-3.872 2.248-.031-.012ZM250.525 129.165l-.006 1.212 3.903-2.267.006-1.168-3.866 2.248-.037-.025Z"
            fill="#E0E0E0"
        />
        <path
            d="M250.525 128.391v.774l.037.025 3.866-2.248v-.781l-3.866 2.249-.037-.019Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="M250.556 117.306v.781h.006l3.897-2.261v-.781l-3.897 2.261h-.006ZM250.55 119.092v.781l.012.006 3.891-2.261v-.78l-3.891 2.26-.012-.006ZM250.531 126.605v.774l.031.019 3.872-2.248v-.781l-3.872 2.248-.031-.012ZM250.525 128.391v.774l.037.025 3.866-2.248v-.781l-3.866 2.249-.037-.019Z"
            fill="#000"
        />
        <path
            d="m250.531 127.379-.006 1.012.037.019 3.866-2.249.006-1.011-3.872 2.248-.031-.019ZM250.549 119.873l-.018 6.732.031.012 3.872-2.248.019-6.751-3.891 2.261-.013-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="m254.465 113.653-10.622-6.133-3.897 2.267 10.616 6.133 3.903-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m243.842 107.52-3.896 2.267-.007 1.386v.781l-.006 1.012v.774l-.019 6.732v.781l-.006 1.005v.781l-.006 1.211 10.616 6.127 3.903-2.267.007-1.168v-.781l.006-1.011v-.781l.019-6.751v-.78l.006-1.012v-.781l.006-1.392-10.623-6.133Z"
            fill="#000"
        />
        <path
            d="M245.216 118.08c2.099 1.212 3.791 3.123 3.791 4.284 0 1.162-1.705 1.106-3.797-.099-2.092-1.206-3.791-3.123-3.791-4.285 0-1.161 1.705-1.105 3.797.1Z"
            fill="#fff"
        />
        <path
            d="m244.068 123.776-10.623-6.127-.019 6.726 10.623 6.133.019-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m244.049 130.508-10.623-6.133v.781l10.617 6.132.006-.78Z"
            fill="#fff"
        />
        <path
            d="m244.043 131.288-10.617-6.132-.006 1.012 10.623 6.126v-1.006Z"
            fill="#E6E6E6"
        />
        <path
            d="m244.043 132.294-10.623-6.126v.774l10.616 6.133.007-.781Z"
            fill="#fff"
        />
        <path
            d="m244.074 119.823-10.617-6.133-.006 1.393 10.623 6.126v-1.386Z"
            fill="#E6E6E6"
        />
        <path
            d="m244.067 123.001-10.616-6.132-.006.78 10.622 6.127v-.775ZM244.074 121.209l-10.623-6.126v.774l10.617 6.133.006-.781Z"
            fill="#fff"
        />
        <path
            d="m244.068 121.99-10.617-6.133v1.012l10.617 6.132v-1.011ZM233.42 126.942v1.211l10.616 6.133v-1.211l-10.616-6.133Z"
            fill="#E6E6E6"
        />
        <path
            d="m244.074 121.996-.007-.006v1.011h.007l3.896-2.26v-1.012l-3.896 2.267ZM244.074 121.209v.006l3.897-2.267.006-1.392-3.903 2.267v1.386Z"
            fill="#E0E0E0"
        />
        <path
            d="m244.074 121.209-.007.781.007.006 3.896-2.267v-.781l-3.896 2.267v-.006ZM244.067 123.001v.775l.007.006 3.89-2.261.006-.78-3.896 2.26h-.007ZM244.049 130.508l-.007.78.032.019 3.872-2.248v-.781l-3.872 2.249-.025-.019ZM244.036 133.075v1.211l3.903-2.267v-1.168l-3.865 2.242-.038-.018Z"
            fill="#E0E0E0"
        />
        <path
            d="m244.042 132.294-.006.781.038.018 3.865-2.242v-.78l-3.865 2.242-.032-.019Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m244.074 121.209-.007.781.007.006 3.896-2.267v-.781l-3.896 2.267v-.006ZM244.067 123.001v.775l.007.006 3.89-2.261.006-.78-3.896 2.26h-.007ZM244.049 130.508l-.007.78.032.019 3.872-2.248v-.781l-3.872 2.249-.025-.019ZM244.042 132.294l-.006.781.038.018 3.865-2.242v-.78l-3.865 2.242-.032-.019Z"
            fill="#000"
        />
        <path
            d="M244.042 131.288v1.006l.032.019 3.865-2.242.007-1.012-3.872 2.248-.032-.019ZM244.068 123.776l-.019 6.732.025.019 3.872-2.249.018-6.757-3.89 2.261-.006-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="m247.977 117.556-10.617-6.133-3.903 2.267 10.616 6.133 3.904-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m237.36 111.423-3.903 2.267-.006 1.393v1.786l-.006.781-.019 6.725v.781l-.006 1.012v1.986l10.616 6.132 3.903-2.267v-1.948l.007-1.012v-.781l.018-6.757.007-.78V118.948l.006-1.392-10.617-6.133Z"
            fill="#000"
        />
        <path
            d="M238.734 121.99c2.092 1.205 3.791 3.122 3.785 4.278-.006 1.155-1.705 1.111-3.797-.1-2.092-1.212-3.791-3.123-3.784-4.278.006-1.155 1.704-1.112 3.796.1Z"
            fill="#fff"
        />
        <path
            d="m273.981 125.862-10.623-6.133-.019 6.732 10.623 6.126.019-6.725Z"
            fill="#E6E6E6"
        />
        <path
            d="m273.962 132.587-10.623-6.126v.774l10.617 6.133.006-.781Z"
            fill="#fff"
        />
        <path
            d="m273.956 133.368-10.617-6.132-.006 1.011 10.623 6.127v-1.006Z"
            fill="#E6E6E6"
        />
        <path
            d="m273.956 134.373-10.623-6.126v.775l10.616 6.132.007-.781Z"
            fill="#fff"
        />
        <path
            d="m273.987 121.902-10.616-6.126-.007 1.386 10.623 6.133v-1.393Z"
            fill="#E6E6E6"
        />
        <path
            d="m273.981 125.081-10.617-6.133-.006.781 10.623 6.133v-.781ZM273.987 123.295l-10.623-6.133v.781l10.617 6.126.006-.774Z"
            fill="#fff"
        />
        <path
            d="m273.981 124.069-10.617-6.126v1.005l10.617 6.133v-1.012ZM263.333 129.022v1.211l10.616 6.133v-1.212l-10.616-6.132Z"
            fill="#E6E6E6"
        />
        <path
            d="m273.987 124.076-.006-.007v1.012l.006.006 3.897-2.267v-1.011l-3.897 2.267ZM273.987 123.295l3.903-2.267v-1.393l-3.903 2.267v1.393Z"
            fill="#E0E0E0"
        />
        <path
            d="m273.987 123.295-.006.774.006.007 3.897-2.267.006-.781-3.903 2.267ZM273.981 125.081v.781l.006.006 3.891-2.267.006-.781-3.897 2.267-.006-.006ZM273.962 132.587l-.006.781.031.019 3.872-2.248v-.781l-3.872 2.248-.025-.019ZM273.95 135.154v1.212l3.903-2.267v-1.168l-3.866 2.248-.037-.025Z"
            fill="#E0E0E0"
        />
        <path
            d="m273.956 134.373-.006.781.037.025 3.866-2.248v-.781l-3.866 2.248-.031-.025Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m273.987 123.295-.006.774.006.007 3.897-2.267.006-.781-3.903 2.267ZM273.981 125.081v.781l.006.006 3.891-2.267.006-.781-3.897 2.267-.006-.006ZM273.962 132.587l-.006.781.031.019 3.872-2.248v-.781l-3.872 2.248-.025-.019ZM273.956 134.373l-.006.781.037.025 3.866-2.248v-.781l-3.866 2.248-.031-.025Z"
            fill="#000"
        />
        <path
            d="M273.956 133.368v1.005l.031.025 3.865-2.248.007-1.011-3.872 2.248-.031-.019ZM273.981 125.862l-.019 6.725.025.019 3.872-2.248.018-6.757-3.89 2.267-.006-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="m277.89 119.635-10.616-6.126-3.903 2.267 10.616 6.126 3.903-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m267.274 113.509-3.904 2.267-.006 1.386v1.786l-.006.781-.019 6.732v.774l-.006 1.012V130.233l10.616 6.133 3.904-2.267V132.15l.006-1.011v-.781l.018-6.757.007-.781v-1.011l.006-.781v-1.393l-10.616-6.126Z"
            fill="#000"
        />
        <path
            d="M268.648 124.069c2.092 1.206 3.79 3.123 3.784 4.278-.006 1.155-1.705 1.112-3.797-.1-2.092-1.211-3.791-3.122-3.784-4.278.006-1.155 1.704-1.111 3.797.1Z"
            fill="#fff"
        />
        <path
            d="m267.492 129.765-10.616-6.133-.019 6.732 10.616 6.133.019-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m267.474 136.497-10.617-6.133-.006.781 10.623 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m267.474 137.271-10.623-6.126v1.005l10.616 6.133.007-1.012Z"
            fill="#E6E6E6"
        />
        <path
            d="m267.467 138.283-10.616-6.133-.006.781 10.622 6.126v-.774Z"
            fill="#fff"
        />
        <path
            d="m267.504 125.812-10.622-6.133v1.386l10.616 6.133.006-1.386Z"
            fill="#E6E6E6"
        />
        <path
            d="m267.492 128.984-10.616-6.126v.774l10.616 6.133v-.781ZM267.499 127.198l-10.617-6.133-.006.781 10.623 6.133v-.781Z"
            fill="#fff"
        />
        <path
            d="m267.499 127.979-10.623-6.133v1.012l10.616 6.126.007-1.005ZM256.845 132.931v1.211l10.616 6.127.006-1.212-10.622-6.126Z"
            fill="#E6E6E6"
        />
        <path
            d="M267.505 127.979h-.007l-.006 1.005.013.006 3.89-2.26.007-1.012-3.897 2.261ZM267.499 127.198h.006l3.897-2.261v-1.392l-3.897 2.267-.006 1.386Z"
            fill="#E0E0E0"
        />
        <path
            d="M267.499 127.198v.781h.006l3.897-2.261v-.781l-3.897 2.261h-.006ZM267.492 128.984v.781l.013.006 3.89-2.261v-.78l-3.89 2.26-.013-.006ZM267.474 136.497v.774l.031.019 3.865-2.248.007-.781-3.872 2.254-.031-.018ZM267.467 139.057l-.006 1.212 3.903-2.261v-1.174l-3.859 2.248-.038-.025Z"
            fill="#E0E0E0"
        />
        <path
            d="M267.467 138.283v.774l.038.025 3.859-2.248.006-.781-3.865 2.249-.038-.019Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="M267.499 127.198v.781h.006l3.897-2.261v-.781l-3.897 2.261h-.006ZM267.492 128.984v.781l.013.006 3.89-2.261v-.78l-3.89 2.26-.013-.006ZM267.474 136.497v.774l.031.019 3.865-2.248.007-.781-3.872 2.254-.031-.018ZM267.467 138.283v.774l.038.025 3.859-2.248.006-.781-3.865 2.249-.038-.019Z"
            fill="#000"
        />
        <path
            d="m267.474 137.271-.007 1.012.038.019 3.865-2.249v-1.011l-3.865 2.248-.031-.019ZM267.492 129.765l-.018 6.732.031.018 3.872-2.254.018-6.751-3.89 2.261-.013-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="m271.401 123.545-10.616-6.133-3.903 2.267 10.622 6.133 3.897-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m260.785 117.412-3.903 2.267v1.386l-.006.781v1.786l-.019 6.732-.006.781v1.005l-.006.781v1.211l10.616 6.127 3.903-2.261v-1.174l.006-.781v-1.011l.007-.781.018-6.751v-.78l.007-1.012v-2.173l-10.617-6.133Z"
            fill="#000"
        />
        <path
            d="M262.159 127.972c2.099 1.212 3.791 3.123 3.791 4.284 0 1.162-1.705 1.106-3.803-.099-2.099-1.206-3.791-3.123-3.785-4.285.007-1.161 1.705-1.105 3.797.1Z"
            fill="#fff"
        />
        <path
            d="m261.004 133.668-10.617-6.127-.018 6.733 10.616 6.126.019-6.732Z"
            fill="#E6E6E6"
        />
        <path
            d="m260.985 140.4-10.616-6.126v.774l10.616 6.132v-.78Z"
            fill="#fff"
        />
        <path
            d="m260.985 141.18-10.616-6.132-.007 1.012 10.623 6.126v-1.006Z"
            fill="#E6E6E6"
        />
        <path
            d="m260.985 142.186-10.623-6.126v.774l10.617 6.133.006-.781Z"
            fill="#fff"
        />
        <path
            d="m261.016 129.715-10.616-6.127-.006 1.387 10.622 6.132v-1.392Z"
            fill="#E6E6E6"
        />
        <path
            d="m261.01 132.893-10.617-6.132-.006.78 10.617 6.127.006-.775ZM261.016 131.107l-10.622-6.132v.78l10.616 6.127.006-.775Z"
            fill="#fff"
        />
        <path
            d="m261.01 131.882-10.616-6.127v1.006l10.616 6.132v-1.011ZM250.362 136.834l-.006 1.211 10.623 6.133v-1.211l-10.617-6.133Z"
            fill="#E6E6E6"
        />
        <path
            d="m261.016 131.888-.006-.006v1.011l.006.007 3.897-2.267v-1.012l-3.897 2.267ZM261.016 131.107l3.897-2.267.006-1.392-3.903 2.267v1.392Z"
            fill="#E0E0E0"
        />
        <path
            d="m261.016 131.107-.006.775.006.006 3.897-2.267v-.781l-3.897 2.267ZM261.01 132.893l-.006.775.012.006 3.891-2.261.006-.78-3.897 2.267-.006-.007ZM260.985 140.4v.78l.031.019 3.872-2.248v-.781l-3.872 2.249-.031-.019ZM260.979 142.967v1.211l3.896-2.267.007-1.168-3.866 2.242-.037-.018Z"
            fill="#E0E0E0"
        />
        <path
            d="m260.985 142.186-.006.781.037.018 3.866-2.242v-.78l-3.866 2.248-.031-.025Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m261.016 131.107-.006.775.006.006 3.897-2.267v-.781l-3.897 2.267ZM261.01 132.893l-.006.775.012.006 3.891-2.261.006-.78-3.897 2.267-.006-.007ZM260.985 140.4v.78l.031.019 3.872-2.248v-.781l-3.872 2.249-.031-.019ZM260.985 142.186l-.006.781.037.018 3.866-2.242v-.78l-3.866 2.248-.031-.025Z"
            fill="#000"
        />
        <path
            d="M260.985 141.18v1.006l.031.025 3.866-2.248.006-1.012-3.872 2.248-.031-.019ZM261.004 133.668l-.019 6.732.031.019 3.872-2.249.019-6.757-3.891 2.261-.012-.006Z"
            fill="#E0E0E0"
        />
        <path
            d="m264.919 127.448-10.616-6.126-3.903 2.266 10.616 6.127 3.903-2.267Z"
            fill="#F0F0F0"
        />
        <path
            opacity={0.1}
            d="m254.303 121.322-3.903 2.266-.007 1.387v1.786l-.006.78-.019 6.733v.774l-.006 1.012v.774l-.006 1.211 10.623 6.133 3.896-2.267.007-1.168v-.78l.006-1.012v-.781l.019-6.757.006-.78V128.84l.006-1.392-10.616-6.126Z"
            fill="#000"
        />
        <path
            d="M255.677 131.882c2.092 1.205 3.79 3.122 3.784 4.278-.006 1.155-1.705 1.111-3.797-.1-2.092-1.212-3.79-3.123-3.79-4.278 0-1.156 1.711-1.112 3.803.1Z"
            fill="#fff"
        />
        <path
            d="m232.358 90.04.007 5.852-10.311-5.995-.006-5.852 10.31 5.996Z"
            fill="#E0E0E0"
        />
        <path
            d="m248.158 80.917.006 5.851-15.799 9.124-.007-5.851 15.8-9.124Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m248.158 80.917.006 5.851-15.799 9.124-.007-5.851 15.8-9.124Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m232.358 90.734-10.31-5.995v-.694l10.31 5.996v.693ZM232.358 90.04l15.8-9.123v.693l-15.8 9.124v-.693Z"
            fill="#000"
        />
        <path
            d="m221.673 81.847 16.249-9.38 10.604 6.158-16.249 9.386-10.604-6.164Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m221.673 81.847 16.249-9.38 10.604 6.158-16.249 9.386-10.604-6.164Z"
            fill="#fff"
        />
        <path
            d="m232.277 88.011.006 2.242-10.604-6.164-.006-2.242 10.604 6.164ZM248.526 78.625l.006 2.248-16.249 9.38-.006-2.242 16.249-9.386Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m248.526 78.625.006 2.248-16.249 9.38-.006-2.242 16.249-9.386Z"
            fill="#000"
        />
        <path
            d="m179.963 57.88-.006 9.498 16.736-9.73.013-9.498-16.743 9.73ZM163.314 48.337l-.012 9.498 16.655 9.543.006-9.499-16.649-9.542Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m163.314 48.337-.012 9.498 16.655 9.543.006-9.499-16.649-9.542Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m179.963 59.003 16.743-9.73V48.15l-16.743 9.73v1.123ZM179.963 57.88l-16.649-9.543v1.118l16.649 9.548V57.88Z"
            fill="#000"
        />
        <path
            d="m197.311 44.584-17.379-9.974-17.218 10.011 17.38 9.967 17.217-10.004Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m197.311 44.584-17.379-9.974-17.218 10.011 17.38 9.967 17.217-10.004Z"
            fill="#fff"
        />
        <path
            d="m180.094 54.588-.012 3.64 17.217-10.004.012-3.64-17.217 10.004Z"
            fill="#E0E0E0"
        />
        <path
            d="m162.715 44.621-.013 3.64 17.38 9.968.012-3.641-17.379-9.967Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m162.715 44.621-.013 3.64 17.38 9.968.012-3.641-17.379-9.967Z"
            fill="#000"
        />
        <path
            d="m205.367 70-.012 9.5 16.743-9.73.006-9.5L205.367 70Z"
            fill="#E0E0E0"
        />
        <path
            d="m188.712 60.452-.006 9.499 16.649 9.548.013-9.498-16.656-9.549Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m188.712 60.452-.006 9.499 16.649 9.548.013-9.498-16.656-9.549Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m205.368 71.125 16.736-9.73v-1.124L205.368 70l-.007 1.124h.007Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m205.368 70-16.656-9.548v1.124l16.649 9.549.007-1.124Z"
            fill="#000"
        />
        <path
            d="m222.71 56.699-17.38-9.967-17.217 10.004 17.379 9.967L222.71 56.7Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m222.71 56.699-17.38-9.967-17.217 10.004 17.379 9.967L222.71 56.7Z"
            fill="#fff"
        />
        <path
            d="m205.492 66.703-.012 3.641 17.217-10.004.013-3.641-17.218 10.004Z"
            fill="#E0E0E0"
        />
        <path
            d="m188.113 56.736-.013 3.641 17.38 9.967.012-3.64-17.379-9.968Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m188.113 56.736-.013 3.641 17.38 9.967.012-3.64-17.379-9.968Z"
            fill="#000"
        />
        <path
            d="m247.178 98.54.006 5.851-10.311-5.995-.006-5.851 10.311 5.995Z"
            fill="#E0E0E0"
        />
        <path
            d="m262.977 89.416.006 5.852-15.8 9.123-.006-5.851 15.8-9.124Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m262.977 89.416.006 5.852-15.8 9.123-.006-5.851 15.8-9.124Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m247.178 99.233-10.311-5.995v-.693l10.311 5.995v.693Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m247.177 98.54 15.8-9.124v.693l-15.8 9.124v-.693Z"
            fill="#000"
        />
        <path
            d="m236.492 90.347 16.25-9.38 10.603 6.163-16.249 9.38-10.604-6.163Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m236.492 90.347 16.25-9.38 10.603 6.163-16.249 9.38-10.604-6.163Z"
            fill="#fff"
        />
        <path
            d="m247.096 96.51.006 2.242-10.604-6.163-.006-2.242 10.604 6.163Z"
            fill="#E0E0E0"
        />
        <path
            d="m263.346 87.13.006 2.242-16.25 9.38-.006-2.242 16.25-9.38Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m263.346 87.13.006 2.242-16.25 9.38-.006-2.242 16.25-9.38Z"
            fill="#000"
        />
        <path
            d="m261.997 107.039.006 5.852-10.31-5.995-.006-5.846 10.31 5.989Z"
            fill="#E0E0E0"
        />
        <path
            d="m277.796 97.915.007 5.852-15.8 9.124-.006-5.852 15.799-9.124Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m277.796 97.915.007 5.852-15.8 9.124-.006-5.852 15.799-9.124Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m261.997 107.733-10.31-5.989v-.694l10.31 5.989v.694ZM261.997 107.039l15.799-9.124v.694l-15.799 9.124v-.694Z"
            fill="#000"
        />
        <path
            d="m251.312 98.852 16.249-9.386 10.61 6.164-16.256 9.38-10.603-6.158Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m251.312 98.852 16.249-9.386 10.61 6.164-16.256 9.38-10.603-6.158Z"
            fill="#fff"
        />
        <path
            d="m261.915 105.01.013 2.242-10.61-6.158-.006-2.242 10.603 6.158Z"
            fill="#E0E0E0"
        />
        <path
            d="m278.171 95.63.006 2.242-16.249 9.38-.012-2.242 16.255-9.38Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m278.171 95.63.006 2.242-16.249 9.38-.012-2.242 16.255-9.38Z"
            fill="#000"
        />
        <path
            d="m258.806 98.784.006 5.832-10.279-5.976-.007-5.827 10.28 5.97Z"
            fill="#E0E0E0"
        />
        <path
            d="m274.549 89.69.006 5.834-15.743 9.092-.006-5.832 15.743-9.093Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m274.549 89.69.006 5.834-15.743 9.092-.006-5.832 15.743-9.093Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m258.806 99.47-10.28-5.97v-.687l10.28 5.97v.687ZM258.806 98.784l15.743-9.093v.693l-15.743 9.087v-.688Z"
            fill="#000"
        />
        <path
            d="m248.158 90.621 16.193-9.348 10.566 6.139-16.193 9.348-10.566-6.139Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m248.158 90.621 16.193-9.348 10.566 6.139-16.193 9.348-10.566-6.139Z"
            fill="#fff"
        />
        <path
            d="m258.724 96.76.006 2.236-10.566-6.139-.006-2.236 10.566 6.14Z"
            fill="#E0E0E0"
        />
        <path
            d="m274.917 87.412.007 2.235-16.194 9.349-.006-2.236 16.193-9.349Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m274.917 87.412.007 2.235-16.194 9.349-.006-2.236 16.193-9.349Z"
            fill="#000"
        />
        <path
            d="m245.135 87.686.006 5.833-10.272-5.97-.007-5.833 10.273 5.97Z"
            fill="#E0E0E0"
        />
        <path
            d="m260.885 78.6.006 5.826-15.749 9.093-.007-5.833 15.75-9.086Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m260.885 78.6.006 5.826-15.749 9.093-.007-5.833 15.75-9.086Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m245.135 88.38-10.273-5.97v-.694l10.273 5.97v.693ZM245.135 87.686l15.75-9.086v.687l-15.75 9.092v-.693Z"
            fill="#000"
        />
        <path
            d="m234.494 79.524 16.193-9.349 10.567 6.14-16.193 9.354-10.567-6.145Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m234.494 79.524 16.193-9.349 10.567 6.14-16.193 9.354-10.567-6.145Z"
            fill="#fff"
        />
        <path
            d="m245.061 85.67.006 2.235L234.5 81.76l-.006-2.236 10.567 6.145Z"
            fill="#E0E0E0"
        />
        <path
            d="m261.254 76.314.006 2.236-16.193 9.355-.006-2.236 16.193-9.355Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m261.254 76.314.006 2.236-16.193 9.355-.006-2.236 16.193-9.355Z"
            fill="#000"
        />
        <path
            d="M192.16 20.272c-2.249-1.299-2.261-3.41 0-4.709l8.149 4.703a8.971 8.971 0 0 1-8.149.006Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.3}
            d="M192.16 20.272c-2.249-1.299-2.261-3.41 0-4.709l8.149 4.703a8.971 8.971 0 0 1-8.149.006Z"
            fill="#000"
        />
        <path
            d="M190.973 20.965c-2.916-1.71-2.916-4.409-.031-6.082l1.193.693c-2.236 1.299-2.224 3.41 0 4.709a8.968 8.968 0 0 0 8.118 0l1.199.693c-2.873 1.66-7.569 1.667-10.479-.013Z"
            fill="#FAFAFA"
        />
        <path
            d="M203.357 22.57a1.878 1.878 0 0 0-.937-1.074l-.937-.537c-2.904 1.68-7.6 1.686-10.51 0s-2.935-4.409-.031-6.095l-.937-.537a5.239 5.239 0 0 0-4.777 0l-17.155 9.992a1.765 1.765 0 0 0-.981 1.18 1.58 1.58 0 0 0 .968 1.561l12.415 7.182a5.215 5.215 0 0 0 4.765 0l17.18-9.992c.799-.45 1.105-1.08.937-1.68Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M181.05 33.574a3.367 3.367 0 0 0 3.385 0l18.922-10.998c.168.625-.138 1.25-.937 1.693l-17.18 9.973a5.214 5.214 0 0 1-4.765 0l-12.402-7.163a1.576 1.576 0 0 1-.968-1.561l13.945 8.056Z"
            fill="#000"
        />
        <path
            d="M192.16 16.132c-2.249-1.3-2.261-3.416 0-4.715l8.124 4.715a8.972 8.972 0 0 1-8.124 0Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.3}
            d="M192.16 16.132c-2.249-1.3-2.261-3.416 0-4.715l8.124 4.715a8.972 8.972 0 0 1-8.124 0Z"
            fill="#000"
        />
        <path
            d="M190.973 16.837c-2.917-1.686-2.935-4.409-.032-6.088l1.193.686c-2.204 1.3-2.204 3.448.025 4.697a8.974 8.974 0 0 0 8.119 0l1.199.687c-2.898 1.698-7.594 1.698-10.504.018Z"
            fill="#FAFAFA"
        />
        <path
            d="M203.357 18.442a1.876 1.876 0 0 0-.937-1.061l-.937-.544c-2.904 1.686-7.6 1.686-10.51 0s-2.935-4.409-.031-6.088l-.937-.544a5.278 5.278 0 0 0-4.778 0l-17.154 9.992a1.727 1.727 0 0 0-.956 1.193 1.587 1.587 0 0 0 .956 1.567l12.415 7.17a5.251 5.251 0 0 0 4.764 0l17.18-9.992c.787-.456 1.093-1.093.925-1.693Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M181.05 29.452a3.392 3.392 0 0 0 3.384 0l18.922-11.01c.169.625-.137 1.25-.936 1.699l-17.18 9.992a5.252 5.252 0 0 1-4.765 0l-12.402-7.176a1.581 1.581 0 0 1-.968-1.567l13.945 8.062Z"
            fill="#000"
        />
        <path
            d="M214.048 34.929c-2.261-1.312-2.261-3.41-.031-4.709l8.156 4.703a8.977 8.977 0 0 1-8.125.006Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.3}
            d="M214.048 34.929c-2.261-1.312-2.261-3.41-.031-4.709l8.156 4.703a8.977 8.977 0 0 1-8.125.006Z"
            fill="#000"
        />
        <path
            d="M212.862 35.622c-2.923-1.686-2.936-4.409-.038-6.095l1.193.693c-2.23 1.3-2.23 3.398.031 4.709a8.975 8.975 0 0 0 8.119 0l1.192.693c-2.891 1.674-7.594 1.674-10.497 0Z"
            fill="#FAFAFA"
        />
        <path
            d="M225.245 37.227a1.873 1.873 0 0 0-.968-1.074l-.936-.537c-2.898 1.68-7.6 1.68-10.504 0s-2.936-4.41-.038-6.095l-.937-.537a5.254 5.254 0 0 0-4.777 0l-17.155 9.992a1.764 1.764 0 0 0-.949 1.199 1.563 1.563 0 0 0 .949 1.56l12.415 7.17a5.215 5.215 0 0 0 4.765 0l17.18-9.992c.812-.456 1.118-1.086.955-1.686Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M202.938 48.23a3.355 3.355 0 0 0 3.378 0l18.929-10.997c.162.625-.144 1.25-.937 1.693l-17.18 9.992a5.211 5.211 0 0 1-4.765 0l-12.433-7.182a1.56 1.56 0 0 1-.968-1.561l13.976 8.056Z"
            fill="#000"
        />
        <path
            d="M214.048 30.807c-2.261-1.299-2.261-3.434-.031-4.683l8.156 4.708a8.977 8.977 0 0 1-8.125-.025Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.3}
            d="M214.048 30.807c-2.261-1.299-2.261-3.434-.031-4.683l8.156 4.708a8.977 8.977 0 0 1-8.125-.025Z"
            fill="#000"
        />
        <path
            d="M212.862 31.494c-2.923-1.686-2.936-4.409-.038-6.089l1.193.687c-2.23 1.28-2.23 3.416.031 4.715a8.975 8.975 0 0 0 8.119 0l1.192.687c-2.891 1.68-7.594 1.68-10.497 0Z"
            fill="#FAFAFA"
        />
        <path
            d="M225.245 33.1a1.878 1.878 0 0 0-.968-1.069l-.937-.543c-2.897 1.686-7.6 1.686-10.504 0s-2.935-4.409-.037-6.089l-.937-.543a5.239 5.239 0 0 0-4.777 0l-17.155 10.01a1.74 1.74 0 0 0-.949 1.193 1.565 1.565 0 0 0 .949 1.555l12.415 7.17a5.23 5.23 0 0 0 4.765 0l17.18-9.992c.811-.456 1.117-1.093.955-1.693Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M202.938 44.103a3.365 3.365 0 0 0 3.379 0l18.928-11.004c.162.625-.144 1.25-.937 1.699l-17.18 9.992a5.231 5.231 0 0 1-4.764 0l-12.434-7.176a1.57 1.57 0 0 1-.968-1.567l13.976 8.056Z"
            fill="#000"
        />
        <path
            d="M242.213 41.311v9.043c0 .906-.581 1.811-1.768 2.498a9.485 9.485 0 0 1-8.618 0c-1.192-.687-1.792-1.592-1.798-2.498V41.31h12.184Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M242.213 41.311v9.043c0 .906-.581 1.811-1.768 2.498a9.485 9.485 0 0 1-8.618 0c-1.192-.687-1.792-1.592-1.798-2.498V41.31h12.184Z"
            fill="#000"
        />
        <path
            d="M240.414 38.813c2.386 1.38 2.405 3.616.031 4.996a9.5 9.5 0 0 1-8.618 0c-2.385-1.374-2.404-3.61 0-4.996a9.526 9.526 0 0 1 8.587 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M240.333 36.802v2.773a2.09 2.09 0 0 1-1.249 1.724 6.55 6.55 0 0 1-5.958 0 2.118 2.118 0 0 1-1.249-1.724v-2.773h8.456Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M240.333 36.802v2.773a2.09 2.09 0 0 1-1.249 1.724 6.55 6.55 0 0 1-5.958 0 2.118 2.118 0 0 1-1.249-1.724v-2.773h8.456Z"
            fill="#000"
        />
        <path
            d="M239.09 35.079c1.649.955 1.655 2.498 0 3.447a6.55 6.55 0 0 1-5.958 0c-1.648-.95-1.655-2.498 0-3.447a6.571 6.571 0 0 1 5.958 0Z"
            fill="#E6E6E6"
        />
        <path
            d="M252.854 47.656v9.068c0 .905-.58 1.81-1.767 2.498a9.485 9.485 0 0 1-8.618 0c-1.193-.687-1.792-1.593-1.799-2.498v-9.068h12.184Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M252.854 47.656v9.068c0 .905-.58 1.81-1.767 2.498a9.485 9.485 0 0 1-8.618 0c-1.193-.687-1.792-1.593-1.799-2.498v-9.068h12.184Z"
            fill="#000"
        />
        <path
            d="M251.055 45.158c2.392 1.38 2.405 3.616.032 4.996a9.488 9.488 0 0 1-8.618 0c-2.386-1.374-2.398-3.61 0-4.996a9.488 9.488 0 0 1 8.586 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M250.974 43.147v2.773a2.072 2.072 0 0 1-1.249 1.724 6.536 6.536 0 0 1-5.951 0 2.107 2.107 0 0 1-1.249-1.724v-2.773h8.449Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M250.974 43.147v2.773a2.072 2.072 0 0 1-1.249 1.724 6.536 6.536 0 0 1-5.951 0 2.107 2.107 0 0 1-1.249-1.724v-2.773h8.449Z"
            fill="#000"
        />
        <path
            d="M249.732 41.424c1.648.949 1.661 2.498 0 3.447a6.545 6.545 0 0 1-5.952 0c-1.655-.95-1.661-2.498 0-3.447a6.552 6.552 0 0 1 5.952 0Z"
            fill="#E6E6E6"
        />
        <path
            d="M263.502 54.001v9.043c0 .905-.587 1.81-1.774 2.498a9.483 9.483 0 0 1-8.618 0c-1.193-.687-1.792-1.593-1.798-2.498V54h12.19Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M263.502 54.001v9.043c0 .905-.587 1.81-1.774 2.498a9.483 9.483 0 0 1-8.618 0c-1.193-.687-1.792-1.593-1.798-2.498V54h12.19Z"
            fill="#000"
        />
        <path
            d="M261.703 51.503c2.386 1.38 2.398 3.616 0 4.996a9.485 9.485 0 0 1-8.618 0c-2.385-1.374-2.398-3.61 0-4.996a9.488 9.488 0 0 1 8.618 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M261.616 49.492v2.773a2.065 2.065 0 0 1-1.249 1.724 6.537 6.537 0 0 1-5.952 0 2.11 2.11 0 0 1-1.248-1.724v-2.773h8.449Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M261.616 49.492v2.773a2.065 2.065 0 0 1-1.249 1.724 6.537 6.537 0 0 1-5.952 0 2.11 2.11 0 0 1-1.248-1.724v-2.773h8.449Z"
            fill="#000"
        />
        <path
            d="M260.373 47.769c1.648.949 1.661 2.498 0 3.447a6.537 6.537 0 0 1-5.952 0c-1.648-.95-1.661-2.498 0-3.447a6.542 6.542 0 0 1 5.952 0Z"
            fill="#E6E6E6"
        />
        <path
            d="M274.143 60.346v9.042c0 .906-.587 1.812-1.767 2.498a9.49 9.49 0 0 1-8.618 0c-1.193-.686-1.793-1.592-1.799-2.498v-9.042h12.184Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M274.143 60.346v9.042c0 .906-.587 1.812-1.767 2.498a9.49 9.49 0 0 1-8.618 0c-1.193-.686-1.793-1.592-1.799-2.498v-9.042h12.184Z"
            fill="#000"
        />
        <path
            d="M272.363 57.848c2.386 1.38 2.399 3.616 0 4.996a9.483 9.483 0 0 1-8.618 0c-2.385-1.374-2.404-3.61-.031-4.996a9.489 9.489 0 0 1 8.649 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M272.263 55.837v2.76a2.09 2.09 0 0 1-1.249 1.724 6.55 6.55 0 0 1-5.957 0 2.114 2.114 0 0 1-1.249-1.724v-2.76h8.455Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M272.263 55.837v2.76a2.09 2.09 0 0 1-1.249 1.724 6.55 6.55 0 0 1-5.957 0 2.114 2.114 0 0 1-1.249-1.724v-2.76h8.455Z"
            fill="#000"
        />
        <path
            d="M271.021 54.113c1.648.95 1.655 2.498 0 3.448a6.571 6.571 0 0 1-5.958 0c-1.649-.95-1.655-2.498 0-3.448a6.55 6.55 0 0 1 5.958 0Z"
            fill="#E6E6E6"
        />
        <path
            d="M232.683 48.605v9.05c0 .905-.587 1.804-1.774 2.497a9.492 9.492 0 0 1-8.612 0c-1.199-.687-1.798-1.592-1.804-2.498v-9.049h12.19Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M232.683 48.605v9.05c0 .905-.587 1.804-1.774 2.497a9.492 9.492 0 0 1-8.612 0c-1.199-.687-1.798-1.592-1.804-2.498v-9.049h12.19Z"
            fill="#000"
        />
        <path
            d="M230.884 46.107c2.386 1.374 2.399 3.61 0 4.996a9.468 9.468 0 0 1-8.611 0c-2.392-1.38-2.405-3.616-.032-4.996a9.488 9.488 0 0 1 8.643 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M230.797 44.084v2.773a2.065 2.065 0 0 1-1.249 1.723 6.576 6.576 0 0 1-5.895.025 2.114 2.114 0 0 1-1.249-1.723v-2.798h8.393Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M230.797 44.084v2.773a2.065 2.065 0 0 1-1.249 1.723 6.576 6.576 0 0 1-5.895.025 2.114 2.114 0 0 1-1.249-1.723v-2.798h8.393Z"
            fill="#000"
        />
        <path
            d="M229.554 42.36c1.649.956 1.661 2.498 0 3.454a6.577 6.577 0 0 1-5.951 0c-1.649-.956-1.662-2.498 0-3.454a6.573 6.573 0 0 1 5.951 0Z"
            fill="#E6E6E6"
        />
        <path
            d="M243.325 54.931v9.05c0 .899-.581 1.804-1.768 2.497a9.504 9.504 0 0 1-8.618 0c-1.193-.686-1.792-1.592-1.798-2.498v-9.048h12.184Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M243.325 54.931v9.05c0 .899-.581 1.804-1.768 2.497a9.504 9.504 0 0 1-8.618 0c-1.193-.686-1.792-1.592-1.798-2.498v-9.048h12.184Z"
            fill="#000"
        />
        <path
            d="M241.526 52.44c2.385 1.374 2.398 3.61.031 4.996a9.507 9.507 0 0 1-8.618 0c-2.386-1.38-2.404-3.616-.031-4.996a9.483 9.483 0 0 1 8.618 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M241.444 50.423v2.779a2.098 2.098 0 0 1-1.249 1.723 6.584 6.584 0 0 1-5.957 0 2.134 2.134 0 0 1-1.249-1.723v-2.78h8.455Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M241.444 50.423v2.779a2.098 2.098 0 0 1-1.249 1.723 6.584 6.584 0 0 1-5.957 0 2.134 2.134 0 0 1-1.249-1.723v-2.78h8.455Z"
            fill="#000"
        />
        <path
            d="M240.202 48.699c1.649.956 1.655 2.498 0 3.454a6.589 6.589 0 0 1-5.958 0c-1.648-.956-1.655-2.498 0-3.454a6.588 6.588 0 0 1 5.958 0Z"
            fill="#E6E6E6"
        />
        <path
            d="M253.966 61.276v9.05c0 .899-.581 1.804-1.768 2.497a9.485 9.485 0 0 1-8.618 0c-1.192-.687-1.792-1.592-1.798-2.498v-9.049h12.184Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M253.966 61.276v9.05c0 .899-.581 1.804-1.768 2.497a9.485 9.485 0 0 1-8.618 0c-1.192-.687-1.792-1.592-1.798-2.498v-9.049h12.184Z"
            fill="#000"
        />
        <path
            d="M252.167 58.778c2.392 1.38 2.405 3.616 0 4.996a9.52 9.52 0 0 1-8.618 0c-2.385-1.38-2.398-3.616 0-4.996a9.512 9.512 0 0 1 8.618 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M252.086 56.767v2.78a2.09 2.09 0 0 1-1.249 1.723 6.574 6.574 0 0 1-5.951 0 2.114 2.114 0 0 1-1.249-1.724v-2.779h8.449Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M252.086 56.767v2.78a2.09 2.09 0 0 1-1.249 1.723 6.574 6.574 0 0 1-5.951 0 2.114 2.114 0 0 1-1.249-1.724v-2.779h8.449Z"
            fill="#000"
        />
        <path
            d="M250.843 55.044c1.649.955 1.662 2.498 0 3.453a6.553 6.553 0 0 1-5.951 0c-1.655-.949-1.661-2.498 0-3.447a6.59 6.59 0 0 1 5.951-.006Z"
            fill="#E6E6E6"
        />
        <path
            d="M264.613 67.621v9.05c0 .898-.587 1.804-1.773 2.497a9.487 9.487 0 0 1-8.618 0c-1.193-.687-1.792-1.592-1.799-2.498v-9.049h12.19Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M264.613 67.621v9.05c0 .898-.587 1.804-1.773 2.497a9.487 9.487 0 0 1-8.618 0c-1.193-.687-1.792-1.592-1.799-2.498v-9.049h12.19Z"
            fill="#000"
        />
        <path
            d="M262.815 65.123c2.385 1.38 2.398 3.616 0 4.996a9.527 9.527 0 0 1-8.618 0c-2.386-1.38-2.398-3.616 0-4.996a9.52 9.52 0 0 1 8.618 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M262.727 63.112v2.773a2.082 2.082 0 0 1-1.249 1.73 6.573 6.573 0 0 1-5.951 0 2.126 2.126 0 0 1-1.249-1.73v-2.773h8.449Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="M262.727 63.112v2.773a2.082 2.082 0 0 1-1.249 1.73 6.573 6.573 0 0 1-5.951 0 2.126 2.126 0 0 1-1.249-1.73v-2.773h8.449Z"
            fill="#000"
        />
        <path
            d="M261.485 61.389c1.648.955 1.661 2.498 0 3.447a6.542 6.542 0 0 1-5.952 0c-1.648-.95-1.661-2.498 0-3.447a6.576 6.576 0 0 1 5.952 0Z"
            fill="#E6E6E6"
        />
        <path
            d="m162.927 87.536 7.656-4.421-.013-2.635-7.65 4.421.007 2.635ZM162.902 79.218l7.656-4.415-.006-2.66-7.656 4.421.006 2.654Z"
            fill="#FAFAFA"
        />
        <path
            d="m162.902 79.218.019 5.683 7.65-4.421-.013-5.677-7.656 4.415Z"
            fill="#E6E6E6"
        />
        <path
            d="m162.902 79.218-.006-2.654-4.172-2.423.006 2.666 4.166 2.417.006-.006ZM162.896 84.913l-4.147-2.41.006 2.61 4.172 2.423-.006-2.635-.025.013Z"
            fill="#EBEBEB"
        />
        <path
            d="m162.921 84.901-.019-5.683-.006.006-4.166-2.416.019 5.695 4.147 2.41.025-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m170.552 72.143-4.172-2.424-7.656 4.422 4.172 2.423 7.656-4.421Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m170.571 80.48-.013-5.677-.006-2.66-4.172-2.424-7.656 4.422.006 2.666.019 5.696.006 2.61 4.172 2.423 7.656-4.421-.012-2.635Z"
            fill="#000"
        />
        <path
            d="m180.019 86.063 7.65-4.422-.006-2.629-7.656 4.415.012 2.636ZM179.994 77.75l7.656-4.42-.012-2.661-7.65 4.421.006 2.66Z"
            fill="#FAFAFA"
        />
        <path
            d="m179.994 77.75.013 5.677 7.656-4.415-.013-5.683-7.656 4.422Z"
            fill="#E6E6E6"
        />
        <path
            d="m179.994 77.75-.006-2.66-4.172-2.423.007 2.667 4.165 2.416h.006ZM179.988 83.44l-4.147-2.405.007 2.605 4.171 2.422-.012-2.635-.019.013Z"
            fill="#EBEBEB"
        />
        <path
            d="m180.007 83.427-.013-5.677h-.006l-4.165-2.416.018 5.701 4.147 2.405.019-.013Z"
            fill="#E0E0E0"
        />
        <path
            d="m187.638 70.669-4.165-2.423-7.657 4.421 4.172 2.423 7.65-4.421Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m187.663 79.012-.012-5.683-.013-2.66-4.165-2.423-7.657 4.421.007 2.667.018 5.701.007 2.605 4.171 2.422 7.65-4.42-.006-2.63Z"
            fill="#000"
        />
        <path
            d="m170.433 92.226 7.657-4.421-.006-2.636-7.657 4.422.006 2.635ZM170.408 83.908l7.656-4.415-.006-2.66-7.656 4.42.006 2.655Z"
            fill="#FAFAFA"
        />
        <path
            d="m170.408 83.908.019 5.683 7.656-4.421-.018-5.677-7.657 4.415Z"
            fill="#E6E6E6"
        />
        <path
            d="m170.408 83.908-.006-2.654-4.165-2.423.006 2.666 4.159 2.417.006-.006ZM170.402 89.603l-4.147-2.41.013 2.61 4.165 2.423-.006-2.635-.025.012Z"
            fill="#EBEBEB"
        />
        <path
            d="m170.427 89.591-.019-5.683-.006.006-4.159-2.416.012 5.695 4.147 2.41.025-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m178.058 76.832-4.171-2.422-7.65 4.42 4.165 2.424 7.656-4.422Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m178.083 85.17-.018-5.677-.007-2.66-4.171-2.424-7.65 4.422.006 2.666.013 5.696.012 2.61 4.165 2.423 7.657-4.421-.007-2.636Z"
            fill="#000"
        />
        <path
            d="m187.526 90.752 7.656-4.42-.012-2.63-7.65 4.421.006 2.63ZM187.501 82.44l7.656-4.42-.006-2.655-7.656 4.421.006 2.654Z"
            fill="#FAFAFA"
        />
        <path
            d="m187.5 82.44.019 5.683 7.65-4.421-.012-5.683-7.657 4.421Z"
            fill="#E6E6E6"
        />
        <path
            d="m187.501 82.44-.007-2.654-4.171-2.429.006 2.667 4.165 2.423.007-.007ZM187.494 88.136l-4.146-2.41.006 2.603 4.172 2.424-.007-2.63-.025.013Z"
            fill="#EBEBEB"
        />
        <path
            d="m187.519 88.123-.018-5.683-.007.007-4.165-2.423.019 5.701 4.146 2.41.025-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m195.151 75.365-4.172-2.423-7.656 4.415 4.171 2.43 7.657-4.422Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m195.169 83.702-.012-5.683-.006-2.654-4.172-2.423-7.656 4.415.006 2.667.019 5.701.006 2.605 4.172 2.422 7.656-4.42-.013-2.63Z"
            fill="#000"
        />
        <path
            d="m177.94 96.916 7.656-4.421-.006-2.636-7.656 4.422.006 2.635ZM177.915 88.604l7.656-4.421-.006-2.654-7.656 4.415.006 2.66Z"
            fill="#FAFAFA"
        />
        <path
            d="m177.915 88.604.018 5.677 7.657-4.422-.019-5.676-7.656 4.421Z"
            fill="#E6E6E6"
        />
        <path
            d="m177.915 88.604-.006-2.66-4.166-2.423.006 2.666 4.16 2.417h.006ZM177.908 94.293l-4.14-2.404.006 2.604 4.166 2.423-.007-2.635-.025.012Z"
            fill="#EBEBEB"
        />
        <path
            d="m177.934 94.28-.019-5.676h-.006l-4.159-2.417.018 5.702 4.141 2.404.025-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m185.565 81.529-4.166-2.423-7.656 4.415 4.166 2.423 7.656-4.415Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m185.59 89.86-.019-5.677-.006-2.654-4.166-2.423-7.656 4.415.006 2.666.019 5.702.006 2.604 4.166 2.423 7.656-4.421-.006-2.636Z"
            fill="#000"
        />
        <path
            d="m195.032 95.442 7.656-4.415-.006-2.635-7.656 4.421.006 2.63ZM195.007 87.13l7.657-4.421-.007-2.654-7.656 4.421.006 2.654Z"
            fill="#FAFAFA"
        />
        <path
            d="m195.007 87.13.019 5.683 7.656-4.421-.018-5.683-7.657 4.421Z"
            fill="#E6E6E6"
        />
        <path
            d="m195.007 87.13-.006-2.654-4.172-2.423.013 2.66 4.159 2.424.006-.007ZM195.001 92.826l-4.147-2.41.012 2.61 4.166 2.416-.006-2.629-.025.013Z"
            fill="#EBEBEB"
        />
        <path
            d="m195.026 92.813-.019-5.683-.006.007-4.159-2.423.012 5.701 4.147 2.41.025-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m202.657 80.055-4.172-2.423-7.656 4.421 4.172 2.423 7.656-4.421Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m202.682 88.392-.019-5.683-.006-2.654-4.172-2.423-7.656 4.421.013 2.66.012 5.702.013 2.61 4.165 2.417 7.656-4.415-.006-2.635Z"
            fill="#000"
        />
        <path
            d="m185.452 101.606 7.65-4.421-.006-2.63-7.656 4.422.012 2.629ZM185.427 93.294l7.656-4.421-.006-2.654-7.656 4.421.006 2.654Z"
            fill="#FAFAFA"
        />
        <path
            d="m185.427 93.294.013 5.683 7.656-4.421-.012-5.683-7.657 4.421Z"
            fill="#E6E6E6"
        />
        <path
            d="m185.427 93.294-.006-2.654-4.171-2.423.006 2.66 4.165 2.417h.006ZM185.421 98.99l-4.147-2.411.007 2.604 4.171 2.423-.012-2.629-.019.013Z"
            fill="#EBEBEB"
        />
        <path
            d="m185.44 98.977-.013-5.683h-.006l-4.165-2.417.019 5.702 4.146 2.41.019-.012Z"
            fill="#E0E0E0"
        />
        <path
            d="m193.077 86.219-4.171-2.423-7.656 4.421 4.171 2.423 7.656-4.421Z"
            fill="#E6E6E6"
        />
        <path
            opacity={0.1}
            d="m193.096 94.556-.012-5.683-.007-2.654-4.171-2.423-7.656 4.421.006 2.66.018 5.702.007 2.604 4.171 2.423 7.65-4.421-.006-2.63Z"
            fill="#000"
        />
        <path
            d="m286.333 135.641-22.969 13.177-109.867-63.43 22.969-13.177 109.867 63.43Z"
            fill="#EBEBEB"
        />
        <path
            d="m286.333 135.641-.006 2.692-22.975 13.177.013-2.692 22.968-13.177Z"
            fill="#E0E0E0"
        />
        <path
            d="m263.364 148.818-.012 2.692-109.861-63.43.006-2.692 109.867 63.43Z"
            fill="#F0F0F0"
        />
        <path
            d="m286.333 104.722-22.969 13.177-109.867-63.43 22.969-13.177 109.867 63.43Z"
            fill="#EBEBEB"
        />
        <path
            d="m286.333 104.722-.006 2.692-22.975 13.177.013-2.692 22.968-13.177Z"
            fill="#E0E0E0"
        />
        <path
            d="m263.364 117.899-.012 2.692-109.861-63.43.006-2.692 109.867 63.43Z"
            fill="#F0F0F0"
        />
        <path
            d="M286.333 73.804 263.364 86.98 153.497 23.55l22.969-13.183 109.867 63.436Z"
            fill="#EBEBEB"
        />
        <path
            d="m286.333 73.804-.006 2.691-22.975 13.177.013-2.691 22.968-13.177Z"
            fill="#E0E0E0"
        />
        <path
            d="m263.364 86.98-.012 2.692-109.861-63.43.006-2.691 109.867 63.43Z"
            fill="#F0F0F0"
        />
        <path
            d="m65.756 176.627-9.917.287-9.917-.287c-.425 6.694.88 13.52 2.685 16.861a4.469 4.469 0 0 0 1.961 1.999c2.93 1.692 7.657 1.692 10.56 0a4.372 4.372 0 0 0 1.961-2.049c1.799-3.353 3.091-10.142 2.667-16.811Z"
            fill="#fff"
        />
        <path
            d="M62.827 172.568c3.884 2.248 3.903 5.882.043 8.118-3.859 2.236-10.135 2.242-14.02 0-3.884-2.242-3.909-5.876-.043-8.118 3.865-2.242 10.135-2.242 14.02 0Z"
            fill="#EBEBEB"
        />
        <path
            d="M61.284 173.461c3.029 1.754 3.048 4.59.038 6.338-3.01 1.749-7.913 1.749-10.942 0-3.028-1.748-3.047-4.584-.037-6.338 3.01-1.755 7.919-1.749 10.941 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M61.284 173.461c3.029 1.754 3.048 4.59.038 6.338-3.01 1.749-7.913 1.749-10.942 0-3.028-1.748-3.047-4.584-.037-6.338 3.01-1.755 7.919-1.749 10.941 0Z"
            fill="#000"
            opacity={0.15}
        />
        <path
            d="M49.531 157.586c-1.611-2.005-3.484-3.797-4.996-5.908-1.005-1.436-1.873-3.191-1.43-4.896a4.375 4.375 0 0 1 3.472-3.054 6.66 6.66 0 0 1 4.715 1.05 14.367 14.367 0 0 1 3.516 3.353 34.971 34.971 0 0 1 7.37 24.98 5.218 5.218 0 0 1-.919 2.873 2.885 2.885 0 0 1-2.966.905c-2.698-.799-2.342-4.453-2.78-6.595a30.245 30.245 0 0 0-3.122-8.424 29.84 29.84 0 0 0-2.86-4.284Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M49.531 157.586c-1.611-2.005-3.484-3.797-4.996-5.908-1.005-1.436-1.873-3.191-1.43-4.896a4.375 4.375 0 0 1 3.472-3.054 6.66 6.66 0 0 1 4.715 1.05 14.367 14.367 0 0 1 3.516 3.353 34.971 34.971 0 0 1 7.37 24.98 5.218 5.218 0 0 1-.919 2.873 2.885 2.885 0 0 1-2.966.905c-2.698-.799-2.342-4.453-2.78-6.595a30.245 30.245 0 0 0-3.122-8.424 29.84 29.84 0 0 0-2.86-4.284Z"
            fill="#fff"
        />
        <path
            d="M58.443 174.166a.248.248 0 0 1-.187-.225c-.188-4.334-1.6-19.134-11.797-27.534a.23.23 0 0 1-.037-.33.235.235 0 0 1 .254-.077c.03.01.058.025.083.045 10.347 8.518 11.777 23.494 11.965 27.878a.235.235 0 0 1-.061.169.231.231 0 0 1-.164.074h-.056Z"
            fill="#F0F0F0"
        />
        <path
            d="M61.184 173.386a7.239 7.239 0 0 1-3.31 4.59 9.336 9.336 0 0 1-4.995.843 21.784 21.784 0 0 1-5.09-1.212c-.812-.275-1.724-.624-1.811-1.655a1.814 1.814 0 0 1 .58-1.43c.167-.161.342-.313.525-.456a.515.515 0 0 0 .014-.827.518.518 0 0 0-.295-.109c-.486-.03-.97-.09-1.449-.181a6.33 6.33 0 0 1-3.04-1.374 5.078 5.078 0 0 1-1.406-2.086 1.944 1.944 0 0 1 .2-2.042 2.18 2.18 0 0 1 1.124-.487c.368-.082.73-.15 1.093-.206a.486.486 0 0 0 .414-.419.478.478 0 0 0-.302-.506l-1.536-.624a2.828 2.828 0 0 1-1.168-.725 2.538 2.538 0 0 1-.3-2.117c.194-.961.525-1.873.75-2.847a6.13 6.13 0 0 0 .1-2.911 24.422 24.422 0 0 1 8.618.575c.848.177 1.65.527 2.354 1.03.956.769 1.205 1.918 1.105 3.167a.22.22 0 0 0 .163.22.225.225 0 0 0 .256-.102l.986-1.811a1.162 1.162 0 0 1 1.524-.493 7.038 7.038 0 0 1 2.248 1.773 3.878 3.878 0 0 1 .962 2.873 24.844 24.844 0 0 1-.718 4.228.393.393 0 0 0 .624.412l.05-.037a1.34 1.34 0 0 1 .925-.269c.868.106 1.093.987 1.149 1.736a14.299 14.299 0 0 1-.344 3.479Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M61.184 173.386a7.239 7.239 0 0 1-3.31 4.59 9.336 9.336 0 0 1-4.995.843 21.784 21.784 0 0 1-5.09-1.212c-.812-.275-1.724-.624-1.811-1.655a1.814 1.814 0 0 1 .58-1.43c.167-.161.342-.313.525-.456a.515.515 0 0 0 .014-.827.518.518 0 0 0-.295-.109c-.486-.03-.97-.09-1.449-.181a6.33 6.33 0 0 1-3.04-1.374 5.078 5.078 0 0 1-1.406-2.086 1.944 1.944 0 0 1 .2-2.042 2.18 2.18 0 0 1 1.124-.487c.368-.082.73-.15 1.093-.206a.486.486 0 0 0 .414-.419.478.478 0 0 0-.302-.506l-1.536-.624a2.828 2.828 0 0 1-1.168-.725 2.538 2.538 0 0 1-.3-2.117c.194-.961.525-1.873.75-2.847a6.13 6.13 0 0 0 .1-2.911 24.422 24.422 0 0 1 8.618.575c.848.177 1.65.527 2.354 1.03.956.769 1.205 1.918 1.105 3.167a.22.22 0 0 0 .163.22.225.225 0 0 0 .256-.102l.986-1.811a1.162 1.162 0 0 1 1.524-.493 7.038 7.038 0 0 1 2.248 1.773 3.878 3.878 0 0 1 .962 2.873 24.844 24.844 0 0 1-.718 4.228.393.393 0 0 0 .624.412l.05-.037a1.34 1.34 0 0 1 .925-.269c.868.106 1.093.987 1.149 1.736a14.299 14.299 0 0 1-.344 3.479Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="M61.184 173.386a7.239 7.239 0 0 1-3.31 4.59 9.336 9.336 0 0 1-4.995.843 21.784 21.784 0 0 1-5.09-1.212c-.812-.275-1.724-.624-1.811-1.655a1.814 1.814 0 0 1 .58-1.43c.167-.161.342-.313.525-.456a.515.515 0 0 0 .014-.827.518.518 0 0 0-.295-.109c-.486-.03-.97-.09-1.449-.181a6.33 6.33 0 0 1-3.04-1.374 5.078 5.078 0 0 1-1.406-2.086 1.944 1.944 0 0 1 .2-2.042 2.18 2.18 0 0 1 1.124-.487c.368-.082.73-.15 1.093-.206a.486.486 0 0 0 .414-.419.478.478 0 0 0-.302-.506l-1.536-.624a2.828 2.828 0 0 1-1.168-.725 2.538 2.538 0 0 1-.3-2.117c.194-.961.525-1.873.75-2.847a6.13 6.13 0 0 0 .1-2.911 24.422 24.422 0 0 1 8.618.575c.848.177 1.65.527 2.354 1.03.956.769 1.205 1.918 1.105 3.167a.22.22 0 0 0 .163.22.225.225 0 0 0 .256-.102l.986-1.811a1.162 1.162 0 0 1 1.524-.493 7.038 7.038 0 0 1 2.248 1.773 3.878 3.878 0 0 1 .962 2.873 24.844 24.844 0 0 1-.718 4.228.393.393 0 0 0 .624.412l.05-.037a1.34 1.34 0 0 1 .925-.269c.868.106 1.093.987 1.149 1.736a14.299 14.299 0 0 1-.344 3.479Z"
            fill="#fff"
        />
        <path
            d="M56.613 177.738a34.988 34.988 0 0 0-2.317-6.732.215.215 0 0 0-.081-.175l-.163-.355a21.702 21.702 0 0 1 2.299-7.688.238.238 0 0 0-.413-.237 22.014 22.014 0 0 0-2.26 7.15 31.48 31.48 0 0 0-9.923-11.896.24.24 0 0 0-.264-.008.237.237 0 0 0-.104.149.235.235 0 0 0 .034.179c.017.027.04.049.065.067 4.996 3.466 8.119 8.274 10.036 12.265a14.403 14.403 0 0 0-8.212-1.112.237.237 0 0 0 0 .462h.087c.044 0 4.553-.83 8.456 1.349a34.227 34.227 0 0 1 2.298 6.657.247.247 0 0 0 .187.188h.088a.236.236 0 0 0 .145-.095.236.236 0 0 0 .042-.168Z"
            fill="#F0F0F0"
        />
        <path
            d="m267.155 226.031-9.917.287-9.917-.287c-.424 6.694.881 13.52 2.686 16.861a4.525 4.525 0 0 0 1.961 1.998c2.928 1.693 7.656 1.693 10.566 0a4.413 4.413 0 0 0 1.961-2.048c1.792-3.366 3.085-10.148 2.66-16.811Z"
            fill="#fff"
        />
        <path
            d="M264.245 221.965c3.885 2.248 3.91 5.883.05 8.119-3.859 2.235-10.142 2.241-14.026 0-3.884-2.242-3.903-5.877-.044-8.119 3.86-2.242 10.117-2.248 14.02 0Z"
            fill="#EBEBEB"
        />
        <path
            d="M262.69 222.839c3.035 1.755 3.048 4.59.038 6.339-3.011 1.749-7.907 1.749-10.942 0s-3.047-4.584-.031-6.339c3.016-1.754 7.906-1.729 10.935 0Z"
            fill="#E0E0E0"
        />
        <path
            d="M262.69 222.839c3.035 1.755 3.048 4.59.038 6.339-3.011 1.749-7.907 1.749-10.942 0s-3.047-4.584-.031-6.339c3.016-1.754 7.906-1.729 10.935 0Z"
            fill="#000"
            opacity={0.15}
        />
        <path
            d="M273.544 183.715c-22.345 7.319-22.551 22.269-17.486 32.911 1.249 2.154 5.115 3.316 8.462-9.924l-5.87.75 6.844-3.466 1.78-5.308-5.702.418 7.238-3.041a107.113 107.113 0 0 1 4.734-12.34Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M273.544 183.715c-22.345 7.319-22.551 22.269-17.486 32.911 1.249 2.154 5.115 3.316 8.462-9.924l-5.87.75 6.844-3.466 1.78-5.308-5.702.418 7.238-3.041a107.113 107.113 0 0 1 4.734-12.34Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="M273.544 183.715c-22.345 7.319-22.551 22.269-17.486 32.911 1.249 2.154 5.115 3.316 8.462-9.924l-5.87.75 6.844-3.466 1.78-5.308-5.702.418 7.238-3.041a107.113 107.113 0 0 1 4.734-12.34Z"
            fill="#fff"
        />
        <path
            d="M267.224 187.456c-11.784 8.942-12.846 19.196-9.517 29.9-1.181-9.423-2.455-18.953 9.517-29.9Z"
            fill="#fff"
        />
        <path
            d="M235.693 198.903c22.026 3.122 24.699 16.986 21.776 27.74-.824 2.217-4.209 3.934-9.529-7.838l5.62-.275-6.95-2.092-2.536-4.652 5.383-.556-7.25-1.63a100.715 100.715 0 0 0-6.514-10.697Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M235.693 198.903c22.026 3.122 24.699 16.986 21.776 27.74-.824 2.217-4.209 3.934-9.529-7.838l5.62-.275-6.95-2.092-2.536-4.652 5.383-.556-7.25-1.63a100.715 100.715 0 0 0-6.514-10.697Z"
            fill="#fff"
        />
        <path
            opacity={0.1}
            d="M235.693 198.903c22.026 3.122 24.699 16.986 21.776 27.74-.824 2.217-4.209 3.934-9.529-7.838l5.62-.275-6.95-2.092-2.536-4.652 5.383-.556-7.25-1.63a100.715 100.715 0 0 0-6.514-10.697Z"
            fill="#000"
        />
        <path
            d="M242.2 201.332c12.49 6.37 15.157 15.743 13.833 26.266-.469-8.974-.868-18.06-13.833-26.266Z"
            fill="#fff"
        />
        <path
            d="M279.989 204.105c-20.196.331-24.162 12.552-22.732 22.569.494 2.092 3.36 4.015 9.468-6.002l-4.996-.874 6.494-1.105 2.811-3.91-4.79-1.099 6.713-.662a92.545 92.545 0 0 1 7.032-8.917Z"
            fill="#75C977"
        />
        <path
            d="M273.85 205.572c-11.941 4.372-15.419 12.49-15.407 22.126 1.43-8.037 2.804-16.187 15.407-22.126Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="M279.989 204.105c-20.196.331-24.162 12.552-22.732 22.569.494 2.092 3.36 4.015 9.468-6.002l-4.996-.874 6.494-1.105 2.811-3.91-4.79-1.099 6.713-.662a92.545 92.545 0 0 1 7.032-8.917Z"
            fill="#fff"
        />
        <path
            d="M35.717 30.295v39.037a.343.343 0 0 0 .194.275 1.03 1.03 0 0 0 .937 0 .344.344 0 0 0 .193-.275V30.295h-1.324ZM74.58 7.445v39.037a.318.318 0 0 0 .193.269 1.017 1.017 0 0 0 .93 0 .318.318 0 0 0 .194-.269V7.445H74.58ZM36.642 75.958c1.311-.755 2.373-.824 3.072-.225l-1.249 2.08a1.374 1.374 0 0 0-1.686 0 4.165 4.165 0 0 0-1.98 3.497c0 1.405.825 1.874 1.993 1.187a4.454 4.454 0 0 0 1.68-1.93l1.286.593a7.75 7.75 0 0 1-3.06 3.316c-2.26 1.312-3.934.506-3.94-1.986a8.039 8.039 0 0 1 3.884-6.532ZM44.767 71.43l3.178 6.37-2.098 1.212-.568-1.249-3.01 1.736-.556 1.911-2.061 1.193 3.122-9.992 1.992-1.18Zm-1.918 6.002 1.836-1.055-.924-2.092-.912 3.122M51.292 67.509a4.908 4.908 0 0 1 2.58-.793l-.625 2.086a3.616 3.616 0 0 0-1.973.505c-.85.494-1.156.993-1.15 1.406 0 1.249 4.041-2.018 4.053 1.005 0 1.424-1.036 3.241-3.153 4.465-1.168.674-2.33.987-3.004.83l.662-2.085a3.747 3.747 0 0 0 2.354-.556c.83-.48 1.156-.937 1.156-1.33 0-1.305-4.053 1.986-4.066-1.062-.006-1.455 1.03-3.247 3.166-4.471ZM61.884 61.545l.019 8.193-2.017 1.168-.007-3.197-2.754 1.592.013 3.198-2.024 1.161-.025-8.193 2.024-1.168.006 3.085 2.754-1.593-.012-3.078 2.023-1.168ZM65.331 59.553l.025 8.2-2.023 1.16-.019-8.192 2.017-1.168ZM72.356 55.5l.007 1.792-3.597 2.073.006 1.387 3.166-1.83.006 1.736-3.166 1.824v1.492l3.734-2.154.007 1.792-5.727 3.31-.025-8.2 5.59-3.222ZM78.664 57.486l1.543 1.686-2.155 1.249-1.299-1.437-1.1.625v2.18l-2.01 1.18v-8.194l3.254-1.873c1.954-1.124 3.178-.675 3.185 1.205a5.165 5.165 0 0 1-1.418 3.379Zm-1.874-.294a2.217 2.217 0 0 0 1.25-1.917c0-.762-.425-.968-1.25-.487l-1.117.624v2.405l1.117-.625Z"
            fill="#E0E0E0"
        />
        <path
            d="m83.829 43.235.056 19.284-54.78 31.625-.057-19.279 54.78-31.63Z"
            fill="#F0F0F0"
        />
        <path
            d="m29.104 94.144-2.33-1.35-.05-19.284 2.324 1.355.056 19.279Z"
            fill="#E0E0E0"
        />
        <path
            d="m29.048 74.865-2.323-1.355 54.78-31.63 2.323 1.355-54.78 31.63Z"
            fill="#F5F5F5"
        />
        <path
            d="M212.412 214.165a2.653 2.653 0 0 0 2.46 1.48 2.617 2.617 0 0 0 1.992-1.686 7.373 7.373 0 0 0 .406-2.691 98.44 98.44 0 0 0-.218-9.106c-2.097.458-4.237.69-6.383.694.325 2.806.652 5.608.981 8.405a7.825 7.825 0 0 0 .762 2.904Z"
            fill="#F28F8F"
        />
        <path
            d="M219.019 209.8c-.787-2.529-1.648-5.115-1.467-7.763-.175.05-.35.088-.525.125.206 3.029.281 6.07.219 9.106a7.395 7.395 0 0 1-.406 2.691 2.626 2.626 0 0 1-1.992 1.686 2.66 2.66 0 0 1-2.461-1.48 7.824 7.824 0 0 1-.737-2.935c-.325-2.806-.651-5.608-.98-8.406h-.668c.568 3.123.162 6.37-.038 9.561-.2 3.192-.169 6.514 1.205 9.399.313.782.855 1.45 1.555 1.917a3.183 3.183 0 0 0 2.498.231 5.557 5.557 0 0 0 2.198-1.361 9.044 9.044 0 0 0 2.655-4.996c.455-2.598-.269-5.252-1.056-7.775Z"
            fill="#455A64"
        />
        <path
            d="m185.908 207.377.519 3.122c2.498-1.18 3.284-2.498 3.284-2.498.063-2.398.038-4.871 0-6.076-.655 1.461-2.104 2.448-3.003 3.797a7.5 7.5 0 0 0-.8 1.655Z"
            fill="#37474F"
        />
        <path
            d="m185.109 210.168 1.318.338-.519-3.123c-.349.893-.543 1.849-.799 2.785Z"
            fill="#263238"
        />
        <path
            d="M189.849 198.447a13.012 13.012 0 0 0-1.031-2.392 6.924 6.924 0 0 1-1.149 3.609c-.893 1.437-2.086 2.679-2.947 4.141-1.043 1.786-1.587 3.878-2.96 5.42a6.489 6.489 0 0 1-5.409 2.111 2.842 2.842 0 0 1-1.979-.893 1.558 1.558 0 0 1-.331-.943 14.16 14.16 0 0 1-2.23 1.955c-.905.624-1.986 1.293-2.135 2.385a2.337 2.337 0 0 0 1.298 2.217 6.13 6.13 0 0 0 2.642.594c1.952.172 3.92.003 5.814-.5a8.056 8.056 0 0 0 4.64-3.366c.462-.821.811-1.702 1.037-2.617.256-.936.474-1.873.799-2.791a7.5 7.5 0 0 1 .812-1.667c.899-1.349 2.348-2.336 3.004-3.797.037-.075.081-.15.112-.231a5.207 5.207 0 0 0 .013-3.235Z"
            fill="#455A64"
        />
        <path
            d="M176.354 211.336a6.484 6.484 0 0 0 5.408-2.111c1.374-1.542 1.917-3.634 2.96-5.42.862-1.462 2.054-2.704 2.947-4.141a6.924 6.924 0 0 0 1.149-3.609l-.324-.625c-2.704.481-5.658.625-8.256 1.53a52.596 52.596 0 0 1-3.048 7.963 20.074 20.074 0 0 1-3.122 4.558c.004.343.12.674.331.943a2.847 2.847 0 0 0 1.955.912Z"
            fill="#F28F8F"
        />
        <path
            d="M183.685 98.634c-.144 2.292-.294 4.577-.437 6.869-5.165 21.295-3.628 53.12-3.628 53.12l.162 38.812a6.599 6.599 0 0 0 5.014.931 6.583 6.583 0 0 0 4.178-2.923c.881-9.549 5.315-24.543 3.985-36.258 1.773-9.224 3.122-22.357 3.122-22.357l4.372 22.713 9.049 43.839c3.99 1.686 7.543.531 8.693-1.024-.925-24.18-.531-35.802-4.259-46.987 1.155-29.976 1.511-43.546-5.802-53.85l.094-3.89-24.543 1.005Z"
            fill="#37474F"
        />
        <path
            opacity={0.2}
            d="M195.082 131.769a17.03 17.03 0 0 1-7.406-3.322 7.44 7.44 0 0 0 5.414 4.84l2.286 9.467.687-5.858-.981-5.127Z"
            fill="#000"
        />
        <path
            d="m190.811 75.109-3.622-.069a8.36 8.36 0 0 0-7.613 4.896l-6.701 14.72c-6.101 1.723-10.316 4.996-15.912 5.389-1.08 0-4.908-1.905-6.407-2.68a.554.554 0 0 0-.48-.012.547.547 0 0 0-.307.369 1.409 1.409 0 0 0 .512 1.467l1.78 1.337c-3.591.762-6.401-1.312-7.644.3-1.243 1.611-.368 4.146 3.497 5.476 3.866 1.331 8.799.625 13.677-.455 4.877-1.081 15.749-4.328 15.749-4.328 9.468-9.168 13.471-26.41 13.471-26.41Z"
            fill="#FFA8A7"
        />
        <path
            d="M190.811 75.109c-7.575-1.174-10.411 2.21-11.672 4.865-1.261 2.654-6.445 14.288-6.445 14.288a50.39 50.39 0 0 0-9.567 4.24c2.729 3.123 2.011 5.771 1.405 6.614 6.726-.943 10.267-1.78 12.047-2.311 1-.291 1.897-.86 2.585-1.642 9.661-11.041 11.778-25.08 11.647-26.054Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M190.811 75.109c-7.575-1.174-10.411 2.21-11.672 4.865-1.261 2.654-6.445 14.288-6.445 14.288a50.39 50.39 0 0 0-9.567 4.24c2.729 3.123 2.011 5.771 1.405 6.614 6.726-.943 10.267-1.78 12.047-2.311 1-.291 1.897-.86 2.585-1.642 9.661-11.041 11.778-25.08 11.647-26.054Z"
            fill="#000"
        />
        <path
            d="m192.691 74.79-2.617.2a3.339 3.339 0 0 0-2.498 1.462l-6.058 8.961a7.267 7.267 0 0 0 .481 8.743 4.245 4.245 0 0 1 .968 3.291l-3.091 23.693c11.897 8.831 30.101 5.227 35.509 2.342 0-8.281-3.035-15.144-5.283-19.097a10.897 10.897 0 0 1-1.043-8.368l1.729-6.151-5.245-14.626-12.852-.45Z"
            fill="#75C977"
        />
        <path
            opacity={0.3}
            d="m192.691 74.79-2.617.2a3.339 3.339 0 0 0-2.498 1.462l-6.058 8.961a7.267 7.267 0 0 0 .481 8.743 4.245 4.245 0 0 1 .968 3.291l-3.091 23.693c11.897 8.831 30.101 5.227 35.509 2.342 0-8.281-3.035-15.144-5.283-19.097a10.897 10.897 0 0 1-1.043-8.368l1.729-6.151-5.245-14.626-12.852-.45Z"
            fill="#000"
        />
        <path
            d="M184.934 60.564a8.435 8.435 0 0 1-1.018-10.578 2.844 2.844 0 0 1-1.071-4.57 2.84 2.84 0 0 1 1.583-.876c1.025-.181 2.049.212 3.067.43 1.743.313 3.527.313 5.27 0 1.755-.255 3.485-.624 5.246-.761 1.766-.193 3.553.06 5.196.737a5.818 5.818 0 0 1 3.36 3.86c1.361-.37 2.979.505 3.853 1.61a6.791 6.791 0 0 1 1.249 3.953c.056 1.406-.138 2.804-.212 4.21a9.631 9.631 0 0 0 .53 4.152c.625 1.518 1.874 2.755 2.292 4.372a4.379 4.379 0 0 1-.027 2.244 4.379 4.379 0 0 1-3.086 3.05 4.373 4.373 0 0 1-2.245.002 11.69 11.69 0 0 0 .412-3.416c-.137 1.548-1.68 2.754-3.122 3.278-1.497.424-3.061.56-4.609.4l-5.464-.212-6.364-.25a8.7 8.7 0 0 1-3.329-.575c-1.817-.837-2.847-2.891-2.96-4.89-.112-1.998.631-4.327 1.449-6.17Z"
            fill="#263238"
        />
        <path
            d="M192.697 69.432v11.31l9.099-6.85v-8.35l-9.099 3.89Z"
            fill="#FFA8A7"
        />
        <path
            opacity={0.3}
            d="M201.796 65.542c-1.399 4.159-6.489 7.313-9.106 7.943v-4.053l9.106-3.89Z"
            fill="#000"
        />
        <path
            d="M200.709 58.934a8.609 8.609 0 0 0-.1 2.193c.078.552.332 1.065.725 1.46a1.622 1.622 0 0 0 1.473.432 2.855 2.855 0 0 1 5.54-1.355 3.61 3.61 0 0 1-.625 2.972 6.703 6.703 0 0 1-2.385 1.986 2.405 2.405 0 0 1-2.873-1.13c-2.779 3.522-7.619 6.157-12.153 5.782a6.538 6.538 0 0 1-3.447-1.249c-1.711-1.33-1.842-3.328-2.061-5.308-.32-2.503-.299-5.04.063-7.537.555-3.447 2.085-6.832 4.764-9.074 1.58 7.525 8.45 10.279 11.079 10.828Z"
            fill="#FFA8A7"
        />
        <path
            d="m191.266 58.085-3.103 3.828 2.891.987.212-4.815ZM193.677 64.767l-2.417.768a1.5 1.5 0 0 0 1.636.737 1.34 1.34 0 0 0 .781-1.505Z"
            fill="#F28F8F"
        />
        <path
            opacity={0.3}
            d="m193.677 64.767-2.417.768a1.5 1.5 0 0 0 1.636.737 1.34 1.34 0 0 0 .781-1.505Z"
            fill="#000"
        />
        <path
            d="M192.128 66.229c.255.091.531.106.794.043a1.25 1.25 0 0 0 .78-1.105 1.385 1.385 0 0 0-1.574 1.062Z"
            fill="#F28F8F"
        />
        <path
            d="M195.55 58.878a.856.856 0 0 1-.566.772.86.86 0 1 1 .566-.772ZM188.331 58.279a.86.86 0 0 1-1.498.536.86.86 0 0 1-.143-.946.863.863 0 0 1 .817-.496.867.867 0 0 1 .824.906ZM187.644 54.813l-1.967 1.249a1.248 1.248 0 0 1 .431-1.33 1.456 1.456 0 0 1 1.536.08ZM195.02 55.038l1.873 1.411a1.245 1.245 0 0 0-.312-1.368 1.45 1.45 0 0 0-1.561-.043Z"
            fill="#263238"
        />
        <path
            d="M192.69 73.891a21.123 21.123 0 0 0-3.634 5.365 1.432 1.432 0 0 0 .229 1.492 1.443 1.443 0 0 0 1.438.462l1.967-.468v-6.85Z"
            fill="#E0E0E0"
        />
        <path
            d="m192.69 80.742 9.106-6.87c.156 4.303-1.936 8.119-3.235 10.049a1.432 1.432 0 0 1-1.032.63 1.435 1.435 0 0 1-1.148-.38l-3.691-3.43Z"
            fill="#E0E0E0"
        />
        <path
            d="M205.542 75.24c-.824 8.119 2.005 12.153 9.468 26.316 0 0-1.73 10.429-4.803 16.3-3.047 1.249-4.577 3.347-6.332 4.246a.572.572 0 0 0-.291.599.575.575 0 0 0 .085.219c.718 1.131 2.592.263 4.309-.724-2.186 3.547-2.81 4.134-3.916 5.239-1.105 1.106-.343 2.898 2.661 2.898s4.696-2.348 5.245-3.122c.55-.775 4.322-8.325 4.322-8.325l6.738-13.664a7.3 7.3 0 0 0 .181-6.132l-7.756-18.248a9.211 9.211 0 0 0-8.474-5.62l-1.437.018Z"
            fill="#FFA8A7"
        />
        <path
            d="M205.543 75.24c-2.717 9.211 7.837 23.924 9.167 26.291-.855 1.986-2.067 10.067-2.067 10.067 4.322.525 5.839 2.773 5.839 2.773l4.472-7.925a9.296 9.296 0 0 0 .43-8.237c-2.148-4.996-5.62-13.065-7.412-17.23-2.636-6.263-8.081-5.808-10.429-5.739Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M205.543 75.24c-2.717 9.211 7.837 23.924 9.167 26.291-.855 1.986-2.067 10.067-2.067 10.067 4.322.525 5.839 2.773 5.839 2.773l4.472-7.925a9.296 9.296 0 0 0 .43-8.237c-2.148-4.996-5.62-13.065-7.412-17.23-2.636-6.263-8.081-5.808-10.429-5.739Z"
            fill="#000"
        />
        <path
            d="m174.886 195.374-.012 69.844 56.523-32.636.012-69.85-56.523 32.642Z"
            fill="#75C977"
        />
        <path
            d="m69.765 134.686-.006 69.843 105.115 60.689.012-69.844-105.121-60.688Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="m174.886 195.374-.012 69.844 56.523-32.636.012-69.85-56.523 32.642Z"
            fill="#000"
        />
        <path
            opacity={0.1}
            d="m69.765 134.686-.006 69.843 105.115 60.689.012-69.844-105.121-60.688Z"
            fill="#000"
        />
        <path
            d="M238.666 164.711 122.853 97.847l-60.338 34.859 115.806 66.865 60.345-34.86Z"
            fill="#75C977"
        />
        <path
            d="m178.321 199.571-.013 4.396 60.345-34.859.013-4.397-60.345 34.86Z"
            fill="#75C977"
        />
        <path
            d="m62.514 132.706-.012 4.403 115.806 66.858.013-4.396-115.807-66.865Z"
            fill="#75C977"
        />
        <path
            opacity={0.1}
            d="M238.666 164.711 122.853 97.847l-60.338 34.859 115.806 66.865 60.345-34.86Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="m178.321 199.571-.013 4.396 60.345-34.859.013-4.397-60.345 34.86Z"
            fill="#fff"
        />
        <path
            opacity={0.3}
            d="m62.514 132.706-.012 4.403 115.806 66.858.013-4.396-115.807-66.865Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="M238.666 164.711 122.853 97.847l-60.339 34.859-.012 4.403 7.263 4.19-.006 63.23 105.115 60.689 56.523-32.636.012-59.29 7.244-4.184.013-4.397Z"
            fill="#000"
        />
        <path
            d="m222.585 154.47-61.969 35.646-28.427-16.568 61.663-35.49 28.733 16.412ZM132.189 173.548v16.474l28.559 16.499-.132-16.405-28.427-16.568Z"
            fill="#263238"
        />
        <path
            d="M222.585 154.47v.961l-61.144 35.072v3.753l6.451 3.697v4.434l-7.145 4.134-.131-16.405 61.969-35.646Z"
            fill="#263238"
        />
        <path
            opacity={0.3}
            d="m222.585 154.47-61.969 35.646-28.427-16.568 61.663-35.49 28.733 16.412Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="M132.189 173.548v16.474l28.559 16.499-.132-16.405-28.427-16.568Z"
            fill="#fff"
        />
        <path
            opacity={0.1}
            d="M222.585 154.47v.961l-61.144 35.072v3.753l6.451 3.697v4.434l-7.145 4.134-.131-16.405 61.969-35.646Z"
            fill="#fff"
        />
        <path
            d="m153.772 119.998-7.494 4.302a.947.947 0 0 1-.962 0l-20.483-11.815a.477.477 0 0 1-.244-.418v1.117a.465.465 0 0 0 .244.413l20.49 11.821a.954.954 0 0 0 .961 0l7.494-4.303a.472.472 0 0 0 .238-.412v-1.118a.485.485 0 0 1-.244.413Z"
            fill="#263238"
        />
        <path
            opacity={0.1}
            d="m153.772 119.998-7.494 4.302a.947.947 0 0 1-.962 0l-20.483-11.815a.477.477 0 0 1-.244-.418v1.117a.465.465 0 0 0 .244.413l20.49 11.821a.954.954 0 0 0 .961 0l7.494-4.303a.472.472 0 0 0 .238-.412v-1.118a.485.485 0 0 1-.244.413Z"
            fill="#fff"
        />
        <path
            d="m124.839 112.485 20.483 11.815a.947.947 0 0 0 .962 0l7.494-4.302a.477.477 0 0 0 0-.831l-20.502-11.865a.98.98 0 0 0-.968 0l-7.469 4.377a.465.465 0 0 0-.237.375v.044a.464.464 0 0 0 .07.223.469.469 0 0 0 .167.164Z"
            fill="#263238"
        />
        <path
            opacity={0.3}
            d="m124.839 112.485 20.483 11.815a.947.947 0 0 0 .962 0l7.494-4.302a.477.477 0 0 0 0-.831l-20.502-11.865a.98.98 0 0 0-.968 0l-7.469 4.377a.465.465 0 0 0-.237.375v.044a.464.464 0 0 0 .07.223.469.469 0 0 0 .167.164Z"
            fill="#fff"
        />
        <path
            d="M144.642 120.366c-.081-.044-.081-.119 0-.169l.831-.48a.286.286 0 0 1 .287 0l2.498 1.448a.083.083 0 0 1 .046.032.087.087 0 0 1-.046.137l-.837.481a.337.337 0 0 1-.287 0l-2.492-1.449ZM144.967 122.046c-.082-.044-.082-.119 0-.162l.83-.488a.34.34 0 0 1 .287 0l.9.519c.081.05.081.125 0 .168l-.837.481a.279.279 0 0 1-.281 0l-.899-.518ZM141.22 120.978c-.082-.044-.082-.119 0-.169l.48-.281a.327.327 0 0 1 .281 0l.906.525c.081.044.081.119 0 .162l-.481.281a.29.29 0 0 1-.287 0l-.899-.518ZM142.162 120.422c-.081-.043-.081-.118 0-.162l.831-.487a.327.327 0 0 1 .287 0l.9.524c.081.044.081.119 0 .163l-.831.487a.341.341 0 0 1-.144.033.34.34 0 0 1-.143-.033l-.9-.525ZM139.821 120.166c-.082-.044-.082-.118 0-.162l.487-.281a.31.31 0 0 1 .281 0l.905.524c.075.044.081.119 0 .163l-.481.281a.333.333 0 0 1-.287 0l-.905-.525ZM140.764 119.623c-.082-.05-.082-.119 0-.169l.836-.481a.291.291 0 0 1 .281 0l.906.519a.086.086 0 0 1 .064.084.086.086 0 0 1-.064.084l-.831.481a.326.326 0 0 1-.287 0l-.905-.518ZM143.561 121.24c-.081-.05-.081-.125 0-.168l.831-.481a.29.29 0 0 1 .287 0l.899.518c.082.044.082.119 0 .169l-.83.481a.34.34 0 0 1-.287 0l-.9-.519ZM144.017 122.595c-.081-.049-.081-.118 0-.168l.481-.281a.327.327 0 0 1 .288 0l.899.524c.081.044.081.119 0 .163l-.487.281a.327.327 0 0 1-.281 0l-.9-.519ZM142.619 121.784c-.082-.044-.082-.119 0-.163l.48-.281a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.519c.081.05.081.124 0 .168l-.481.281a.327.327 0 0 1-.287 0l-.899-.524ZM137.96 118.005c-.081-.043-.081-.118 0-.168l.83-.481a.327.327 0 0 1 .288 0l.899.518c.081.05.081.119 0 .169l-.837.481a.287.287 0 0 1-.281 0l-.899-.519ZM136.561 117.194c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.831.487a.327.327 0 0 1-.287 0l-.899-.524ZM135.599 117.743c-.081-.044-.081-.118 0-.162l.481-.281a.289.289 0 0 1 .287 0l.899.518c.082.044.082.119 0 .169l-.48.281a.341.341 0 0 1-.144.033.341.341 0 0 1-.144-.033l-.899-.525ZM137.017 118.549c-.075-.05-.082-.125 0-.169l.48-.281a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.487.281a.314.314 0 0 1-.281 0l-.899-.518ZM138.416 119.361c-.075-.044-.075-.119 0-.169l.48-.275a.302.302 0 0 1 .288 0l.905.519c.075.043.075.118 0 .168l-.481.275a.288.288 0 0 1-.143.037.289.289 0 0 1-.144-.037l-.905-.518ZM141.07 116.806c-.082-.05-.082-.118 0-.168l.83-.481a.292.292 0 0 1 .288 0l.905.518c.075.044.075.119 0 .169l-.831.481a.333.333 0 0 1-.287 0l-.905-.519ZM139.109 117.169c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.837.487a.327.327 0 0 1-.287 0l-.893-.524ZM125.82 112.085c-.082-.043-.082-.118 0-.162l.481-.281a.275.275 0 0 1 .281 0l.905.518c.081.044.081.119 0 .169l-.481.275a.299.299 0 0 1-.287 0l-.899-.519ZM146.059 116.544a.09.09 0 0 1-.046-.031.085.085 0 0 1-.018-.053c0-.019.006-.038.018-.053a.09.09 0 0 1 .046-.031l.837-.481a.327.327 0 0 1 .287 0l.9.518c.081.05.081.119 0 .169l-.831.48a.289.289 0 0 1-.287 0l-.906-.518ZM137.654 111.679a.075.075 0 0 1-.04-.032.088.088 0 0 1 0-.098.08.08 0 0 1 .04-.032l.836-.487a.314.314 0 0 1 .281 0l.906.524c.075.044.081.119 0 .163l-.831.487a.337.337 0 0 1-.287 0l-.905-.525ZM135.162 116.388c-.081-.044-.081-.119 0-.169l.831-.48a.327.327 0 0 1 .287 0l.899.518c.081.05.081.125 0 .168l-.831.481a.286.286 0 0 1-.287 0l-.899-.518ZM137.729 116.376c-.081-.05-.081-.125 0-.169l.83-.481a.291.291 0 0 1 .144-.037c.05 0 .1.012.144.037l.899.518c.081.044.081.119 0 .163l-.831.487a.337.337 0 0 1-.287 0l-.899-.518ZM132.82 116.126c-.081-.044-.081-.119 0-.163l.487-.281a.327.327 0 0 1 .281 0l.906.519c.081.05.081.118 0 .168l-.481.281a.327.327 0 0 1-.287 0l-.906-.524ZM139.715 116.051c-.081-.044-.081-.119 0-.163l.83-.487a.34.34 0 0 1 .288 0l.899.525c.081.044.081.119 0 .162l-.831.487a.326.326 0 0 1-.287 0l-.899-.524ZM141.75 115.626a.09.09 0 0 1-.04-.032.094.094 0 0 1-.015-.049c0-.018.006-.035.015-.049a.083.083 0 0 1 .04-.032l.837-.487a.314.314 0 0 1 .281 0l.906.524c.081.044.081.119 0 .163l-.831.487a.34.34 0 0 1-.287 0l-.906-.525ZM133.763 115.582c-.081-.05-.081-.124 0-.168l.837-.481a.278.278 0 0 1 .281 0l.905.518c.082.044.082.119 0 .163l-.83.487a.333.333 0 0 1-.287 0l-.906-.519ZM136.342 115.576c-.075-.05-.075-.125 0-.168l.837-.481a.279.279 0 0 1 .281 0l.906.518c.081.044.081.119 0 .169l-.831.481a.34.34 0 0 1-.287 0l-.906-.519ZM131.415 115.32a.097.097 0 0 1-.053-.084c0-.018.005-.035.015-.05a.084.084 0 0 1 .038-.034l.481-.282a.34.34 0 0 1 .287 0l.918.556a.09.09 0 0 1 .04.032.088.088 0 0 1-.04.131l-.481.281a.308.308 0 0 1-.287 0l-.918-.55ZM138.353 115.239a.092.092 0 0 1-.038-.035.088.088 0 0 1 0-.099.092.092 0 0 1 .038-.035l.837-.481a.287.287 0 0 1 .281 0l.905.519c.082.05.082.118 0 .168l-.83.481a.29.29 0 0 1-.287 0l-.906-.518ZM140.395 114.846c-.081-.044-.081-.119 0-.169l.825-.5a.339.339 0 0 1 .287 0l.899.519c.081.05.081.125 0 .168l-.837.481a.286.286 0 0 1-.287 0l-.887-.499ZM132.358 114.802a.097.097 0 0 1-.04-.032.088.088 0 0 1 .04-.131l.831-.487a.339.339 0 0 1 .287 0l.906.525a.09.09 0 0 1 .04.032.097.097 0 0 1 .015.049.091.091 0 0 1-.015.049.083.083 0 0 1-.04.032l-.831.487a.327.327 0 0 1-.287 0l-.906-.524ZM134.974 114.802c-.081-.044-.081-.119 0-.169l.831-.481a.34.34 0 0 1 .287 0l.9.519c.081.05.081.125 0 .168l-.831.481a.29.29 0 0 1-.287 0l-.9-.518ZM136.998 114.452c-.081-.044-.081-.119 0-.162l.83-.487a.327.327 0 0 1 .288 0l.905.524c.016.007.03.018.04.032a.088.088 0 0 1-.04.131l-.837.487a.32.32 0 0 1-.281 0l-.905-.525ZM139.04 114.059c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.831.487a.327.327 0 0 1-.287 0l-.899-.524ZM133.582 113.977c-.081-.043-.081-.118 0-.162l.83-.487a.327.327 0 0 1 .288 0l.899.525c.081.043.081.118 0 .162l-.831.487a.327.327 0 0 1-.287 0l-.899-.525ZM130.959 113.965c-.081-.05-.081-.125 0-.169l.831-.481a.3.3 0 0 1 .287 0l.899.519a.089.089 0 0 1 .047.031.091.091 0 0 1 .018.053.091.091 0 0 1-.018.053.089.089 0 0 1-.047.031l-.836.481a.314.314 0 0 1-.281 0l-.9-.518ZM135.643 113.671c-.081-.049-.081-.118 0-.168l.83-.481a.292.292 0 0 1 .288 0l.899.518c.081.05.081.119 0 .169l-.812.468a.308.308 0 0 1-.287 0l-.918-.506ZM137.679 113.278c-.075-.044-.075-.119 0-.169l.83-.48a.327.327 0 0 1 .288 0l.905.518c.075.05.075.125 0 .168l-.83.481a.292.292 0 0 1-.288 0l-.905-.518ZM132.196 113.178a.08.08 0 0 1-.04-.032.088.088 0 0 1 0-.098.075.075 0 0 1 .04-.032l.836-.487a.314.314 0 0 1 .281 0l.906.524c.081.044.081.119 0 .163l-.831.487a.336.336 0 0 1-.287 0l-.905-.525ZM129.56 113.153c-.081-.044-.081-.119 0-.162l.831-.487a.327.327 0 0 1 .287 0l.9.524c.081.044.081.119 0 .163l-.831.487a.34.34 0 0 1-.287 0l-.9-.525ZM139.059 112.504c-.081-.05-.081-.125 0-.169l.837-.481a.284.284 0 0 1 .281 0l6.507 3.747c.075.044.081.119 0 .163l-.831.487a.332.332 0 0 1-.287 0l-6.507-3.747ZM130.815 112.385c-.081-.05-.081-.125 0-.169l.831-.48a.289.289 0 0 1 .287 0l.906.518c.075.044.075.119 0 .168l-.831.481a.327.327 0 0 1-.287 0l-.906-.518ZM129.435 111.586c-.081-.044-.081-.119 0-.169l.831-.481a.341.341 0 0 1 .144-.033.34.34 0 0 1 .143.033l.9.519c.081.049.081.118 0 .168l-.831.481a.29.29 0 0 1-.287 0l-.9-.518ZM126.763 111.536c-.082-.044-.082-.119 0-.163l.836-.487a.327.327 0 0 1 .281 0l2.305 1.33c.081.05.081.119 0 .169l-.831.481a.308.308 0 0 1-.287 0l-2.304-1.33ZM128.055 110.786a.09.09 0 0 1-.046-.031.091.091 0 0 1-.018-.053c0-.019.007-.038.018-.053a.09.09 0 0 1 .046-.031l.837-.481a.314.314 0 0 1 .281 0l.906.518c.081.05.081.125 0 .169l-.831.481a.299.299 0 0 1-.287 0l-.906-.519ZM134.219 116.938c-.081-.05-.081-.125 0-.169l.481-.281a.327.327 0 0 1 .287 0l.9.525c.081.043.081.118 0 .162l-.481.281a.341.341 0 0 1-.144.033.341.341 0 0 1-.144-.033l-.899-.518ZM130.016 114.508c-.075-.043-.081-.118 0-.162l.481-.281a.327.327 0 0 1 .287 0l.899.518c.082.05.082.125 0 .169l-.487.281a.32.32 0 0 1-.281 0l-.899-.525ZM128.617 113.703c-.081-.044-.081-.119 0-.169l.481-.275a.3.3 0 0 1 .287 0l.899.519c.082.043.082.118 0 .162l-.48.281a.292.292 0 0 1-.288 0l-.899-.518ZM127.218 112.891c-.081-.044-.081-.119 0-.163l.481-.281a.34.34 0 0 1 .287 0l.9.525c.081.044.081.119 0 .162l-.481.281a.327.327 0 0 1-.288 0l-.899-.524ZM141.875 118.767c-.081-.043-.081-.118 0-.168l.831-.481a.327.327 0 0 1 .287 0l.899.518c.082.05.082.119 0 .169l-.83.481a.3.3 0 0 1-.287 0l-.9-.519ZM140.489 117.968a.09.09 0 0 1-.04-.032.088.088 0 0 1 0-.098.083.083 0 0 1 .04-.032l.837-.487a.313.313 0 0 1 .281 0l.905.518c.082.05.082.125 0 .168l-.83.481a.29.29 0 0 1-.287 0l-.906-.518ZM142.431 117.587c-.081-.044-.081-.119 0-.162l.837-.487a.326.326 0 0 1 .287 0l.899.524c.082.044.082.119 0 .163l-.83.487a.34.34 0 0 1-.287 0l-.906-.525ZM150.256 118.967c-.081-.044-.081-.118 0-.162l.831-.487a.326.326 0 0 1 .287 0l.906.524c.016.007.03.018.04.032a.097.097 0 0 1 .015.049.091.091 0 0 1-.015.049.092.092 0 0 1-.04.033l-.837.487a.327.327 0 0 1-.281 0l-.906-.525ZM148.857 118.162c-.081-.05-.081-.119 0-.169l.831-.481a.288.288 0 0 1 .143-.037c.051 0 .1.012.144.037l.899.518c.082.05.082.119 0 .169l-.83.481a.333.333 0 0 1-.287 0l-.9-.518ZM145.141 119.173a.083.083 0 0 1-.04-.032.088.088 0 0 1 0-.098.09.09 0 0 1 .04-.032l.83-.487a.327.327 0 0 1 .288 0l.905.524c.017.007.03.018.04.033a.088.088 0 0 1 0 .098.09.09 0 0 1-.04.032l-.83.487a.341.341 0 0 1-.144.033.341.341 0 0 1-.144-.033l-.905-.525ZM147.221 118.786c-.082-.05-.082-.125 0-.169l.836-.48a.292.292 0 0 1 .288 0l2.585 1.492c.016.007.03.018.04.032a.088.088 0 0 1-.04.131l-.837.487a.323.323 0 0 1-.281 0l-2.591-1.493ZM143.786 118.374c-.081-.05-.081-.119 0-.169l.831-.481a.296.296 0 0 1 .287 0l.899.519c.081.05.081.118 0 .168l-.83.481a.316.316 0 0 1-.288 0l-.899-.518ZM145.822 117.98c-.075-.043-.075-.118 0-.168l.837-.481a.32.32 0 0 1 .281 0l.905.518c.081.05.081.119 0 .169l-.83.481a.302.302 0 0 1-.288 0l-.905-.519ZM144.467 117.194c-.082-.044-.082-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.831.487a.326.326 0 0 1-.287 0l-.899-.524ZM146.546 119.966c-.081-.043-.081-.118 0-.168l.831-.481a.326.326 0 0 1 .287 0l1.905 1.099a.09.09 0 0 1 .04.032.088.088 0 0 1 0 .098.083.083 0 0 1-.04.032l-.856.469a.323.323 0 0 1-.281 0l-1.886-1.081ZM143.255 119.567c-.081-.05-.081-.125 0-.169l.831-.481a.299.299 0 0 1 .287 0l.899.519a.089.089 0 0 1 .047.031.091.091 0 0 1 .018.053.091.091 0 0 1-.018.053.089.089 0 0 1-.047.031l-.836.481a.327.327 0 0 1-.288 0l-.893-.518ZM136.255 110.886c-.075-.05-.081-.118 0-.168l.83-.481a.292.292 0 0 1 .288 0l.905.518c.016.008.029.02.039.035a.096.096 0 0 1 0 .099.101.101 0 0 1-.039.035l-.83.481a.302.302 0 0 1-.288 0l-.905-.519ZM135.406 109.687c-.082-.044-.082-.118 0-.168l.218-.125a.292.292 0 0 1 .287 0l.981.562c.081.05.081.125 0 .168l-.219.131a.322.322 0 0 1-.287 0l-.98-.568ZM133.607 110.924c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.905.525c.016.006.03.017.04.032.01.014.015.031.015.049a.086.086 0 0 1-.055.081l-.83.487a.327.327 0 0 1-.288 0l-.905-.524ZM129.354 110.037c-.081-.05-.081-.119 0-.169l.837-.481a.302.302 0 0 1 .287 0l1.768 1.018c.016.008.029.02.038.035a.089.089 0 0 1 0 .099.092.092 0 0 1-.038.035l-.831.481a.308.308 0 0 1-.287 0l-1.774-1.018ZM130.703 109.25c-.081-.05-.081-.125 0-.169l.831-.48a.286.286 0 0 1 .287 0l2.448 1.411c.081.05.081.125 0 .169l-.831.48a.289.289 0 0 1-.287 0l-2.448-1.411ZM131.571 111.317c-.081-.044-.081-.119 0-.162l.831-.487a.326.326 0 0 1 .287 0l.899.524c.081.044.081.119 0 .163l-.83.487a.34.34 0 0 1-.288 0l-.899-.525ZM134.974 111.711c-.081-.044-.081-.119 0-.169l.831-.481a.327.327 0 0 1 .287 0l.9.518c.081.05.081.125 0 .169l-.831.481a.3.3 0 0 1-.287 0l-.9-.518ZM132.926 112.104c-.081-.05-.081-.119 0-.169l.831-.48a.289.289 0 0 1 .287 0l.899.518c.081.05.081.118 0 .168l-.837.481a.286.286 0 0 1-.287 0l-.893-.518ZM136.324 112.491c-.082-.044-.082-.118 0-.162l.83-.487a.327.327 0 0 1 .287 0l.9.524c.081.044.081.119 0 .163l-.837.487a.337.337 0 0 1-.287 0l-.893-.525ZM134.282 112.885a.082.082 0 0 1-.04-.033.088.088 0 0 1 0-.098.085.085 0 0 1 .04-.032l.83-.487a.337.337 0 0 1 .287 0l.906.525c.075.043.081.118 0 .162l-.831.487a.322.322 0 0 1-.287 0l-.905-.524ZM143.093 116.413c-.081-.044-.081-.119 0-.169l.831-.48a.326.326 0 0 1 .287 0l.899.518c.081.05.081.125 0 .168l-.83.481a.292.292 0 0 1-.288 0l-.899-.518ZM139.346 118.811a.09.09 0 0 1-.04-.032.088.088 0 0 1 0-.098.083.083 0 0 1 .04-.032l.831-.487a.327.327 0 0 1 .287 0l.905.524a.085.085 0 0 1 .04.032.088.088 0 0 1-.04.131l-.83.487a.34.34 0 0 1-.287 0l-.906-.525ZM147.465 117.35c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.044.081.118 0 .162l-.831.487a.326.326 0 0 1-.287 0l-.899-.524ZM134.038 108.894c-.081-.044-.081-.119 0-.162l.225-.131a.326.326 0 0 1 .287 0l.98.568c.082.044.082.119 0 .162l-.224.131a.314.314 0 0 1-.281 0l-.987-.568ZM132.664 108.107c-.075-.05-.081-.118 0-.168l.225-.125a.289.289 0 0 1 .287 0l.981.562c.075.043.075.118 0 .168l-.225.125a.292.292 0 0 1-.288 0l-.98-.562ZM133.426 109.25c-.082-.044-.082-.119 0-.162l.224-.131a.314.314 0 0 1 .281 0l.981.562c.081.05.081.124 0 .168l-.219.131a.322.322 0 0 1-.287 0l-.98-.568Z"
            fill="#263238"
        />
        <g opacity={0.5} fill="#fff">
            <path d="M144.642 120.366c-.081-.044-.081-.119 0-.169l.831-.48a.286.286 0 0 1 .287 0l2.498 1.448a.083.083 0 0 1 .046.032.087.087 0 0 1-.046.137l-.837.481a.337.337 0 0 1-.287 0l-2.492-1.449ZM144.967 122.046c-.082-.044-.082-.119 0-.162l.83-.488a.34.34 0 0 1 .287 0l.9.519c.081.05.081.125 0 .168l-.837.481a.279.279 0 0 1-.281 0l-.899-.518ZM141.22 120.978c-.082-.044-.082-.119 0-.169l.48-.281a.327.327 0 0 1 .281 0l.906.525c.081.044.081.119 0 .162l-.481.281a.29.29 0 0 1-.287 0l-.899-.518ZM142.162 120.422c-.081-.043-.081-.118 0-.162l.831-.487a.327.327 0 0 1 .287 0l.9.524c.081.044.081.119 0 .163l-.831.487a.341.341 0 0 1-.144.033.34.34 0 0 1-.143-.033l-.9-.525ZM139.821 120.166c-.082-.044-.082-.118 0-.162l.487-.281a.31.31 0 0 1 .281 0l.905.524c.075.044.081.119 0 .163l-.481.281a.333.333 0 0 1-.287 0l-.905-.525ZM140.764 119.623c-.082-.05-.082-.119 0-.169l.836-.481a.291.291 0 0 1 .281 0l.906.519a.086.086 0 0 1 .064.084.086.086 0 0 1-.064.084l-.831.481a.326.326 0 0 1-.287 0l-.905-.518ZM143.561 121.24c-.081-.05-.081-.125 0-.168l.831-.481a.29.29 0 0 1 .287 0l.899.518c.082.044.082.119 0 .169l-.83.481a.34.34 0 0 1-.287 0l-.9-.519ZM144.017 122.595c-.081-.049-.081-.118 0-.168l.481-.281a.327.327 0 0 1 .288 0l.899.524c.081.044.081.119 0 .163l-.487.281a.327.327 0 0 1-.281 0l-.9-.519ZM142.619 121.784c-.082-.044-.082-.119 0-.163l.48-.281a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.519c.081.05.081.124 0 .168l-.481.281a.327.327 0 0 1-.287 0l-.899-.524ZM137.96 118.005c-.081-.043-.081-.118 0-.168l.83-.481a.327.327 0 0 1 .288 0l.899.518c.081.05.081.119 0 .169l-.837.481a.287.287 0 0 1-.281 0l-.899-.519ZM136.561 117.194c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.831.487a.327.327 0 0 1-.287 0l-.899-.524ZM135.599 117.743c-.081-.044-.081-.118 0-.162l.481-.281a.292.292 0 0 1 .288 0l.899.518c.081.044.081.119 0 .169l-.481.281a.341.341 0 0 1-.144.033.34.34 0 0 1-.143-.033l-.9-.525ZM137.017 118.549c-.075-.05-.081-.125 0-.169l.481-.281a.341.341 0 0 1 .144-.033.34.34 0 0 1 .143.033l.899.525c.082.043.082.118 0 .162l-.487.281a.314.314 0 0 1-.281 0l-.899-.518ZM138.416 119.361c-.075-.044-.075-.119 0-.169l.48-.275a.302.302 0 0 1 .288 0l.905.519c.075.043.075.118 0 .168l-.481.275a.288.288 0 0 1-.143.037.289.289 0 0 1-.144-.037l-.905-.518ZM141.07 116.806c-.082-.05-.082-.118 0-.168l.83-.481a.292.292 0 0 1 .288 0l.905.518c.075.044.075.119 0 .169l-.831.481a.333.333 0 0 1-.287 0l-.905-.519ZM139.109 117.169c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.837.487a.327.327 0 0 1-.287 0l-.893-.524ZM125.82 112.085c-.082-.043-.082-.118 0-.162l.481-.281a.275.275 0 0 1 .281 0l.905.518c.081.044.081.119 0 .169l-.481.275a.299.299 0 0 1-.287 0l-.899-.519ZM146.059 116.544a.09.09 0 0 1-.046-.031.085.085 0 0 1-.018-.053c0-.019.006-.038.018-.053a.09.09 0 0 1 .046-.031l.837-.481a.327.327 0 0 1 .287 0l.9.518c.081.05.081.119 0 .169l-.831.48a.289.289 0 0 1-.287 0l-.906-.518ZM137.654 111.679a.083.083 0 0 1-.04-.032.088.088 0 0 1 0-.098.09.09 0 0 1 .04-.032l.837-.487a.313.313 0 0 1 .281 0l.905.524c.075.044.082.119 0 .163l-.83.487a.337.337 0 0 1-.287 0l-.906-.525ZM135.162 116.388c-.081-.044-.081-.119 0-.169l.831-.48a.327.327 0 0 1 .287 0l.899.518c.081.05.081.125 0 .168l-.831.481a.286.286 0 0 1-.287 0l-.899-.518ZM137.729 116.376c-.081-.05-.081-.125 0-.169l.83-.481a.292.292 0 0 1 .288 0l.899.518c.081.044.081.119 0 .163l-.831.487a.337.337 0 0 1-.287 0l-.899-.518ZM132.82 116.126c-.081-.044-.081-.119 0-.163l.487-.281a.327.327 0 0 1 .281 0l.906.519c.081.05.081.118 0 .168l-.481.281a.327.327 0 0 1-.287 0l-.906-.524ZM139.715 116.051c-.081-.044-.081-.119 0-.163l.83-.487a.34.34 0 0 1 .288 0l.899.525c.081.044.081.119 0 .162l-.831.487a.326.326 0 0 1-.287 0l-.899-.524ZM141.75 115.626a.09.09 0 0 1-.04-.032.097.097 0 0 1-.015-.049c0-.018.006-.035.015-.049a.083.083 0 0 1 .04-.032l.837-.487a.314.314 0 0 1 .281 0l.906.524c.081.044.081.119 0 .163l-.831.487a.34.34 0 0 1-.287 0l-.906-.525ZM133.763 115.582c-.081-.05-.081-.124 0-.168l.837-.481a.278.278 0 0 1 .281 0l.905.518c.082.044.082.119 0 .163l-.83.487a.333.333 0 0 1-.287 0l-.906-.519ZM136.342 115.576c-.075-.05-.075-.125 0-.168l.837-.481a.279.279 0 0 1 .281 0l.906.518c.081.044.081.119 0 .169l-.831.481a.34.34 0 0 1-.287 0l-.906-.519ZM131.415 115.32a.097.097 0 0 1-.053-.084c0-.018.005-.035.015-.05a.084.084 0 0 1 .038-.034l.481-.282a.34.34 0 0 1 .287 0l.918.556a.09.09 0 0 1 .04.032.088.088 0 0 1-.04.131l-.481.281a.308.308 0 0 1-.287 0l-.918-.55ZM138.353 115.239a.092.092 0 0 1-.038-.035.088.088 0 0 1 0-.099.092.092 0 0 1 .038-.035l.837-.481a.287.287 0 0 1 .281 0l.905.519c.082.05.082.118 0 .168l-.83.481a.29.29 0 0 1-.287 0l-.906-.518ZM140.395 114.846c-.081-.044-.081-.119 0-.169l.825-.5a.339.339 0 0 1 .287 0l.899.519c.081.05.081.125 0 .168l-.837.481a.286.286 0 0 1-.287 0l-.887-.499ZM132.358 114.802a.097.097 0 0 1-.04-.032.088.088 0 0 1 .04-.131l.831-.487a.339.339 0 0 1 .287 0l.906.525a.09.09 0 0 1 .04.032.097.097 0 0 1 .015.049.091.091 0 0 1-.015.049.083.083 0 0 1-.04.032l-.831.487a.327.327 0 0 1-.287 0l-.906-.524ZM134.974 114.802c-.081-.044-.081-.119 0-.169l.831-.481a.34.34 0 0 1 .287 0l.9.519c.081.05.081.125 0 .168l-.831.481a.29.29 0 0 1-.287 0l-.9-.518ZM136.998 114.452c-.081-.044-.081-.119 0-.162l.83-.487a.327.327 0 0 1 .288 0l.905.524c.016.007.03.018.04.032a.088.088 0 0 1-.04.131l-.837.487a.32.32 0 0 1-.281 0l-.905-.525ZM139.04 114.059c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.831.487a.327.327 0 0 1-.287 0l-.899-.524ZM133.582 113.977c-.081-.043-.081-.118 0-.162l.83-.487a.327.327 0 0 1 .288 0l.899.525c.081.043.081.118 0 .162l-.831.487a.327.327 0 0 1-.287 0l-.899-.525ZM130.959 113.965c-.081-.05-.081-.125 0-.169l.831-.481a.3.3 0 0 1 .287 0l.899.519a.089.089 0 0 1 .047.031.091.091 0 0 1 .018.053.091.091 0 0 1-.018.053.089.089 0 0 1-.047.031l-.836.481a.314.314 0 0 1-.281 0l-.9-.518ZM135.643 113.671c-.081-.05-.081-.118 0-.168l.83-.481a.292.292 0 0 1 .288 0l.899.518c.081.05.081.119 0 .169l-.812.468a.308.308 0 0 1-.287 0l-.918-.506ZM137.679 113.278c-.075-.044-.075-.119 0-.169l.83-.48a.327.327 0 0 1 .288 0l.905.518c.075.05.075.125 0 .168l-.83.481a.292.292 0 0 1-.288 0l-.905-.518ZM132.196 113.178a.08.08 0 0 1-.04-.032.088.088 0 0 1 0-.098.075.075 0 0 1 .04-.032l.836-.487a.314.314 0 0 1 .281 0l.906.524c.081.044.081.119 0 .163l-.831.487a.336.336 0 0 1-.287 0l-.905-.525ZM129.56 113.153c-.081-.044-.081-.119 0-.162l.831-.487a.327.327 0 0 1 .287 0l.9.524c.081.044.081.119 0 .163l-.831.487a.34.34 0 0 1-.287 0l-.9-.525ZM139.059 112.504c-.081-.05-.081-.125 0-.169l.837-.481a.284.284 0 0 1 .281 0l6.507 3.747c.075.044.081.119 0 .163l-.831.487a.332.332 0 0 1-.287 0l-6.507-3.747ZM130.815 112.385c-.081-.05-.081-.125 0-.169l.831-.48a.289.289 0 0 1 .287 0l.906.518c.075.044.075.119 0 .168l-.831.481a.327.327 0 0 1-.287 0l-.906-.518ZM129.435 111.586c-.081-.044-.081-.119 0-.169l.831-.481a.341.341 0 0 1 .144-.033.34.34 0 0 1 .143.033l.9.519c.081.049.081.118 0 .168l-.831.481a.29.29 0 0 1-.287 0l-.9-.518ZM126.763 111.536c-.082-.044-.082-.119 0-.163l.836-.487a.327.327 0 0 1 .281 0l2.305 1.33c.081.05.081.119 0 .169l-.831.481a.308.308 0 0 1-.287 0l-2.304-1.33ZM128.055 110.786a.09.09 0 0 1-.046-.031.091.091 0 0 1-.018-.053c0-.019.007-.038.018-.053a.09.09 0 0 1 .046-.031l.837-.481a.314.314 0 0 1 .281 0l.906.518c.081.05.081.125 0 .169l-.831.481a.299.299 0 0 1-.287 0l-.906-.519ZM134.219 116.938c-.081-.05-.081-.125 0-.169l.481-.281a.327.327 0 0 1 .287 0l.9.525c.081.043.081.118 0 .162l-.481.281a.341.341 0 0 1-.144.033.341.341 0 0 1-.144-.033l-.899-.518ZM130.017 114.508c-.075-.043-.082-.118 0-.162l.48-.281a.327.327 0 0 1 .288 0l.899.518c.081.05.081.125 0 .169l-.487.281a.328.328 0 0 1-.141.033.327.327 0 0 1-.14-.033l-.899-.525ZM128.618 113.703c-.082-.044-.082-.119 0-.169l.48-.275a.302.302 0 0 1 .288 0l.899.519c.081.043.081.118 0 .162l-.481.281a.29.29 0 0 1-.287 0l-.899-.518ZM127.219 112.891c-.082-.044-.082-.119 0-.163l.48-.281a.34.34 0 0 1 .288 0l.899.525c.081.044.081.119 0 .162l-.481.281a.326.326 0 0 1-.287 0l-.899-.524ZM141.875 118.767c-.081-.043-.081-.118 0-.168l.831-.481a.327.327 0 0 1 .287 0l.899.518c.082.05.082.119 0 .169l-.83.481a.3.3 0 0 1-.287 0l-.9-.519ZM140.489 117.968a.09.09 0 0 1-.04-.032.088.088 0 0 1 0-.098.083.083 0 0 1 .04-.032l.837-.487a.313.313 0 0 1 .281 0l.905.518c.082.05.082.125 0 .168l-.83.481a.29.29 0 0 1-.287 0l-.906-.518ZM142.431 117.587c-.081-.044-.081-.119 0-.162l.837-.487a.326.326 0 0 1 .287 0l.899.524c.082.044.082.119 0 .163l-.83.487a.34.34 0 0 1-.287 0l-.906-.525ZM150.256 118.967c-.081-.044-.081-.118 0-.162l.831-.487a.326.326 0 0 1 .287 0l.906.524c.016.007.03.018.04.032a.097.097 0 0 1 .015.049.091.091 0 0 1-.015.049.092.092 0 0 1-.04.033l-.837.487a.327.327 0 0 1-.281 0l-.906-.525ZM148.857 118.162c-.081-.05-.081-.119 0-.169l.831-.481a.288.288 0 0 1 .143-.037c.051 0 .1.012.144.037l.899.518c.082.05.082.119 0 .169l-.83.481a.333.333 0 0 1-.287 0l-.9-.518ZM145.141 119.173a.083.083 0 0 1-.04-.032.091.091 0 0 1-.015-.049c0-.017.006-.034.015-.049a.09.09 0 0 1 .04-.032l.831-.487a.327.327 0 0 1 .287 0l.906.524c.016.007.03.018.04.033a.088.088 0 0 1 0 .098.097.097 0 0 1-.04.032l-.831.487a.34.34 0 0 1-.143.033.341.341 0 0 1-.144-.033l-.906-.525ZM147.221 118.786c-.081-.05-.081-.125 0-.169l.837-.48a.289.289 0 0 1 .287 0l2.586 1.492c.016.007.03.018.039.032a.09.09 0 0 1 .016.049.084.084 0 0 1-.016.049.084.084 0 0 1-.039.033l-.837.487a.327.327 0 0 1-.281 0l-2.592-1.493ZM143.786 118.374c-.081-.05-.081-.119 0-.169l.831-.481a.3.3 0 0 1 .287 0l.9.519c.081.05.081.118 0 .168l-.831.481a.312.312 0 0 1-.287 0l-.9-.518ZM145.822 117.98c-.075-.043-.075-.118 0-.168l.837-.481a.328.328 0 0 1 .141-.033c.048 0 .096.012.14.033l.906.518c.081.05.081.119 0 .169l-.831.481a.3.3 0 0 1-.287 0l-.906-.519ZM144.467 117.194c-.081-.044-.081-.119 0-.163l.831-.487a.34.34 0 0 1 .143-.033c.05 0 .099.012.144.033l.899.525c.081.043.081.118 0 .162l-.83.487a.327.327 0 0 1-.288 0l-.899-.524ZM146.547 119.966c-.081-.043-.081-.118 0-.168l.83-.481a.327.327 0 0 1 .288 0l1.904 1.099c.017.006.03.018.04.032a.088.088 0 0 1 0 .098.079.079 0 0 1-.04.032l-.855.469a.327.327 0 0 1-.281 0l-1.886-1.081ZM143.256 119.567c-.081-.05-.081-.125 0-.169l.83-.481a.302.302 0 0 1 .288 0l.899.519a.086.086 0 0 1 .064.084.086.086 0 0 1-.064.084l-.837.481a.327.327 0 0 1-.287 0l-.893-.518ZM136.255 110.886c-.075-.05-.081-.118 0-.168l.83-.481a.292.292 0 0 1 .288 0l.905.518c.016.008.029.02.039.035a.096.096 0 0 1 0 .099.101.101 0 0 1-.039.035l-.83.481a.302.302 0 0 1-.288 0l-.905-.519ZM135.406 109.687c-.082-.044-.082-.118 0-.168l.218-.125a.292.292 0 0 1 .287 0l.981.562c.081.05.081.125 0 .168l-.219.131a.322.322 0 0 1-.287 0l-.98-.568ZM133.607 110.924c-.081-.044-.081-.119 0-.163l.831-.487a.34.34 0 0 1 .143-.033c.05 0 .099.012.144.033l.906.525c.016.006.03.017.04.032a.091.091 0 0 1 .015.049.094.094 0 0 1-.015.049.09.09 0 0 1-.04.032l-.831.487a.327.327 0 0 1-.287 0l-.906-.524ZM129.354 110.037c-.081-.05-.081-.119 0-.169l.837-.481a.302.302 0 0 1 .287 0l1.768 1.018c.016.008.029.02.038.035a.089.089 0 0 1 0 .099.092.092 0 0 1-.038.035l-.831.481a.308.308 0 0 1-.287 0l-1.774-1.018ZM130.703 109.25c-.081-.05-.081-.125 0-.169l.831-.48a.29.29 0 0 1 .287 0l2.448 1.411c.082.05.082.125 0 .169l-.83.48a.292.292 0 0 1-.288 0l-2.448-1.411ZM131.571 111.317c-.081-.044-.081-.119 0-.162l.831-.487a.326.326 0 0 1 .287 0l.899.524c.081.044.081.119 0 .163l-.83.487a.34.34 0 0 1-.288 0l-.899-.525ZM134.975 111.711c-.081-.044-.081-.119 0-.169l.831-.481a.327.327 0 0 1 .287 0l.899.518c.081.05.081.125 0 .169l-.831.481a.296.296 0 0 1-.287 0l-.899-.518ZM132.927 112.104c-.082-.05-.082-.119 0-.169l.83-.48a.292.292 0 0 1 .287 0l.9.518c.081.05.081.118 0 .168l-.837.481a.29.29 0 0 1-.287 0l-.893-.518ZM136.324 112.491c-.082-.044-.082-.118 0-.162l.83-.487a.327.327 0 0 1 .287 0l.9.524c.081.044.081.119 0 .163l-.837.487a.337.337 0 0 1-.287 0l-.893-.525ZM134.282 112.885a.082.082 0 0 1-.04-.033.088.088 0 0 1 0-.098.085.085 0 0 1 .04-.032l.83-.487a.337.337 0 0 1 .287 0l.906.525c.075.043.081.118 0 .162l-.831.487a.322.322 0 0 1-.287 0l-.905-.524ZM143.093 116.413c-.081-.044-.081-.119 0-.169l.831-.48a.326.326 0 0 1 .287 0l.899.518c.081.05.081.125 0 .168l-.83.481a.292.292 0 0 1-.288 0l-.899-.518ZM139.346 118.811a.09.09 0 0 1-.04-.032.088.088 0 0 1 0-.098.083.083 0 0 1 .04-.032l.831-.487a.327.327 0 0 1 .287 0l.905.524a.085.085 0 0 1 .04.032.088.088 0 0 1-.04.131l-.83.487a.34.34 0 0 1-.287 0l-.906-.525ZM147.465 117.35c-.081-.044-.081-.119 0-.163l.83-.487a.341.341 0 0 1 .144-.033c.05 0 .099.012.144.033l.899.525c.081.044.081.118 0 .162l-.831.487a.326.326 0 0 1-.287 0l-.899-.524ZM134.038 108.894c-.081-.044-.081-.119 0-.162l.225-.131a.326.326 0 0 1 .287 0l.98.568c.082.044.082.119 0 .162l-.224.131a.314.314 0 0 1-.281 0l-.987-.568ZM132.664 108.107c-.075-.05-.081-.118 0-.168l.225-.125a.289.289 0 0 1 .287 0l.981.562c.075.043.075.118 0 .168l-.225.125a.292.292 0 0 1-.288 0l-.98-.562ZM133.426 109.25c-.081-.044-.081-.119 0-.162l.225-.131a.313.313 0 0 1 .281 0l.98.562c.082.05.082.124 0 .168l-.218.131a.327.327 0 0 1-.287 0l-.981-.568Z" />
        </g>
        <path
            d="m110.263 106.521-19.472 11.241 32.449 18.71 19.466-11.216-32.443-18.735Z"
            fill="#263238"
        />
        <path
            d="M90.791 117.762v6.532l32.449 18.716v-6.538l-32.448-18.71ZM142.706 125.256v6.532L123.24 143.01v-6.538l19.466-11.216Z"
            fill="#263238"
        />
        <path
            opacity={0.3}
            d="m110.263 106.521-19.472 11.241 32.449 18.71 19.466-11.216-32.443-18.735Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="M90.791 117.762v6.532l32.449 18.716v-6.538l-32.448-18.71Z"
            fill="#fff"
        />
        <path
            opacity={0.1}
            d="M142.706 125.256v6.532L123.24 143.01v-6.538l19.466-11.216Z"
            fill="#fff"
        />
        <path
            d="m127.756 100.694-28.67-16.555a.4.4 0 0 0-.394 0h-.032l-.705.381a.412.412 0 0 0-.231.375v20.146a1.25 1.25 0 0 0 .624 1.08l28.671 16.556a.417.417 0 0 0 .431 0l.699-.381h.044a.423.423 0 0 0 .187-.344v-20.177a1.245 1.245 0 0 0-.624-1.081Z"
            fill="#263238"
        />
        <path
            opacity={0.4}
            d="m127.755 100.694-28.67-16.555a.4.4 0 0 0-.393 0h-.032l-.705.381a.406.406 0 0 1 .387 0l28.67 16.555a1.256 1.256 0 0 1 .625 1.075v20.146a.41.41 0 0 1-.194.349l.7-.38h.043a.426.426 0 0 0 .188-.344v-20.146a1.26 1.26 0 0 0-.165-.623 1.262 1.262 0 0 0-.454-.458Z"
            fill="#fff"
        />
        <path
            opacity={0.1}
            d="M127.637 122.296v-20.128a1.25 1.25 0 0 0-.625-1.074l-28.67-16.555a.412.412 0 0 0-.625.362v20.146a1.25 1.25 0 0 0 .625 1.081l28.67 16.555a.413.413 0 0 0 .625-.387Z"
            fill="#fff"
        />
        <path
            d="M99.378 101.538a.769.769 0 0 1 .337.624v2.954c0 .218-.156.306-.343.2a.756.756 0 0 1-.344-.594v-2.953c-.018-.25.132-.338.35-.231ZM100.577 102.249a.754.754 0 0 1 .337.587v2.961c0 .218-.156.299-.343.193a.754.754 0 0 1-.343-.593v-2.954c.006-.219.156-.306.349-.194ZM101.795 102.936a.746.746 0 0 1 .344.594v2.954c0 .218-.157.306-.344.193a.742.742 0 0 1-.343-.624v-2.954c.006-.163.156-.256.343-.163ZM103.019 103.661a.744.744 0 0 1 .344.624v2.954c0 .219-.156.306-.344.194a.723.723 0 0 1-.343-.625v-2.954c0-.212.156-.293.343-.193ZM122.067 114.533a.753.753 0 0 1 .337.625v2.954c0 .218-.156.306-.344.193a.733.733 0 0 1-.343-.587v-2.96c.006-.243.143-.337.35-.225ZM123.29 115.239a.762.762 0 0 1 .337.624v2.954c0 .219-.156.306-.343.2a.754.754 0 0 1-.344-.593v-2.998c.007-.206.169-.293.35-.187ZM124.514 115.945a.76.76 0 0 1 .337.593v2.954c0 .218-.156.306-.343.2a.753.753 0 0 1-.343-.625v-2.954c.006-.187.156-.275.349-.168ZM125.738 116.675a.764.764 0 0 1 .338.594v2.953c0 .225-.157.306-.344.2a.753.753 0 0 1-.343-.624v-2.954c.006-.212.156-.3.349-.169ZM104.274 120.441l6.495 3.697 6.514-3.697-6.508-3.772-6.501 3.772Z"
            fill="#263238"
        />
        <path
            d="M104.274 120.441v.631l6.495 3.697v-.631l-6.495-3.697Z"
            fill="#263238"
        />
        <path
            opacity={0.1}
            d="m104.274 120.441 6.495 3.697 6.514-3.697-6.508-3.772-6.501 3.772Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="M104.274 120.441v.631l6.495 3.697v-.631l-6.495-3.697Z"
            fill="#fff"
        />
        <path
            d="m104.274 120.441 5.427-21.583 6.464 3.729-5.396 21.551-6.495-3.697Z"
            fill="#263238"
        />
        <path
            d="m111.456 123.745 4.709-18.96v-2.198l-5.402 21.551v.631l6.519-3.697v-.631l-5.826 3.304Z"
            fill="#263238"
        />
        <path
            opacity={0.2}
            d="m104.274 120.441 5.427-21.583 6.464 3.729-5.396 21.551-6.495-3.697Z"
            fill="#fff"
        />
        <path
            opacity={0.05}
            d="m111.456 123.745 4.709-18.96v-2.198l-5.402 21.551v.631l6.519-3.697v-.631l-5.826 3.304Z"
            fill="#fff"
        />
        <path
            d="m160.779 130.146 4.64 5.52-18.029 5.052-4.64-5.52 18.029-5.052Zm-11.422 9.367 13.208-3.703c-.406-.481-.063-1.062.774-1.299l-2.286-2.717a2.676 2.676 0 0 1-1.917-.187 1.136 1.136 0 0 1-.324-.269l-13.221 3.71c.406.481.062 1.068-.768 1.299l2.285 2.716a2.664 2.664 0 0 1 1.911.188c.124.069.234.16.325.268"
            fill="#F0F0F0"
        />
        <path
            d="M156.114 134.249c.211.117.401.269.562.449.693.831.1 1.83-1.33 2.23a4.544 4.544 0 0 1-3.292-.319 2.033 2.033 0 0 1-.555-.456c-.7-.83-.107-1.823 1.324-2.229a4.533 4.533 0 0 1 3.291.325Z"
            fill="#F0F0F0"
        />
        <path
            d="M163.339 134.517c-.837.237-1.18.818-.774 1.299l-13.227 3.703a1.167 1.167 0 0 0-.325-.268 2.665 2.665 0 0 0-1.911-.188l-2.286-2.716c.831-.231 1.174-.818.769-1.299l13.208-3.703c.09.108.2.199.324.268a2.683 2.683 0 0 0 1.918.188l2.304 2.716Zm-7.994 2.411c1.43-.4 2.024-1.399 1.331-2.23a2.16 2.16 0 0 0-.562-.449 4.535 4.535 0 0 0-3.292-.325c-1.43.406-2.023 1.399-1.323 2.229.156.184.344.338.555.456a4.542 4.542 0 0 0 3.291.319Z"
            fill="#E0E0E0"
        />
        <path
            d="M169.416 134.249a1.315 1.315 0 0 1 .805 1.492c-.293.906-1.792 1.499-3.36 1.33a3.882 3.882 0 0 1-1.498-.462c-.656-.375-.987-.924-.806-1.486.287-.906 1.786-1.505 3.353-1.33a3.805 3.805 0 0 1 1.506.456Z"
            fill="#FAFAFA"
        />
        <path
            d="M170.271 140.069c-.911-.1-1.786.25-1.954.774l-5.127-.556c.106-.324-.088-.624-.463-.868a2.362 2.362 0 0 0-.899-.262l2.667-8.362c.911.094 1.786-.25 1.954-.781l5.127.563c-.106.331.088.624.469.868.27.147.568.238.874.268l-2.648 8.356Zm-3.409-2.998c1.567.169 3.066-.424 3.359-1.33a1.319 1.319 0 0 0-.805-1.492 3.8 3.8 0 0 0-1.505-.456c-1.568-.175-3.067.424-3.354 1.33-.181.562.15 1.111.806 1.486.463.254.973.412 1.499.462Z"
            fill="#E0E0E0"
        />
        <path
            d="m174.418 130.289-3.647 11.416-10.404-1.13 3.64-11.41 10.411 1.124Zm-6.101 10.554c.168-.524 1.042-.874 1.954-.774l2.667-8.356a2.303 2.303 0 0 1-.875-.268c-.38-.219-.574-.537-.468-.868l-5.127-.563c-.169.531-1.043.875-1.955.781l-2.685 8.362c.308.029.607.118.881.262.374.225.568.544.462.868l5.127.556"
            fill="#FAFAFA"
        />
        <path
            d="M158.081 130.252a1.357 1.357 0 0 1 .812 1.411c-.2.918-1.637 1.561-3.217 1.443a3.942 3.942 0 0 1-1.673-.475 1.35 1.35 0 0 1-.831-1.392c.2-.912 1.643-1.555 3.216-1.443a4.008 4.008 0 0 1 1.693.456Z"
            fill="#fff"
        />
        <path
            d="M164.657 133.599c-.918-.069-1.755.306-1.874.843l-14.575-1.086a.773.773 0 0 0-.481-.806 2.274 2.274 0 0 0-.975-.281l.625-2.991c.918.068 1.755-.306 1.873-.843l14.576 1.08a.795.795 0 0 0 .487.812c.3.166.633.262.974.281l-.63 2.991Zm-8.981-.512c1.58.119 3.017-.525 3.217-1.443a1.354 1.354 0 0 0-.831-1.392 4.009 4.009 0 0 0-1.674-.475c-1.573-.112-3.016.531-3.216 1.443a1.349 1.349 0 0 0 .831 1.392 3.942 3.942 0 0 0 1.673.475Z"
            fill="#E0E0E0"
        />
        <path
            d="m166.636 129.165-1.311 6.083-19.903-1.474 1.312-6.083 19.902 1.474Zm-3.853 5.308c.119-.537.956-.911 1.874-.843l.624-2.991a2.27 2.27 0 0 1-.974-.281.794.794 0 0 1-.487-.812l-14.576-1.08c-.112.537-.949.912-1.873.843l-.625 2.991c.342.019.675.115.975.281a.773.773 0 0 1 .48.806l14.576 1.086M164.67 142.011c1.186.681 1.192 1.792 0 2.498a4.721 4.721 0 0 1-4.278 0c-1.187-.681-1.193-1.792 0-2.498a4.703 4.703 0 0 1 4.278 0Z"
            fill="#fff"
        />
        <path
            d="m166.018 136.659 7.887 4.553-14.85 8.63-7.888-4.552 14.851-8.631Zm-5.727 11.597 10.904-6.32a.757.757 0 0 1-.516-.721.762.762 0 0 1 .516-.721l-3.891-2.249a2.753 2.753 0 0 1-2.498 0l-10.872 6.32a.763.763 0 0 1 0 1.443l3.884 2.242a2.742 2.742 0 0 1 2.498 0"
            fill="#fff"
        />
        <path
            d="M171.195 140.494a.765.765 0 0 0-.516.721.764.764 0 0 0 .516.721l-10.878 6.32a2.742 2.742 0 0 0-2.498 0l-3.903-2.229a.774.774 0 0 0 .374-.278.769.769 0 0 0 0-.887.761.761 0 0 0-.374-.278l10.872-6.32a2.766 2.766 0 0 0 2.498 0l3.909 2.23Zm-10.76 3.99a4.721 4.721 0 0 0 4.278 0c1.18-.687 1.174-1.799 0-2.498a4.704 4.704 0 0 0-4.284 0c-1.174.681-1.168 1.792 0 2.498"
            fill="#E6E6E6"
        />
        <path
            d="M170.115 145.402a.362.362 0 0 1-.282-.144.366.366 0 0 1-.055-.312l2.548-7.918c.681-2.211 1.455-4.715 3.653-6.002a2.205 2.205 0 0 1 2.38.244 1.467 1.467 0 0 1 .624 1.58l-2.348 8.374a.347.347 0 0 1-.64.078.36.36 0 0 1-.035-.265l2.355-8.375a.86.86 0 0 0-.063-.477.86.86 0 0 0-.312-.366 1.497 1.497 0 0 0-1.599-.187c-1.96 1.149-2.66 3.41-3.334 5.62l-.2.625-2.348 7.288a.346.346 0 0 1-.133.175.346.346 0 0 1-.211.062Z"
            fill="#455A64"
        />
        <path
            d="m166.792 148.468-.093 35.64 23.281-13.439-3.966-33.56-19.222 11.359Z"
            fill="#75C977"
        />
        <path
            d="M166.792 148.468v-2.623l-4.309.294-6.351 32.511 10.567 5.458.093-35.64Z"
            fill="#75C977"
        />
        <path
            d="m166.793 145.845-3.847 31.694 3.753 6.569.094-38.263ZM156.132 178.65l6.814-1.111 3.753 6.569-10.567-5.458Z"
            fill="#75C977"
        />
        <path
            d="m162.483 146.139 20.971-12.003-.931 2.973h3.491l-19.222 11.359v-2.623l-4.309.294Z"
            fill="#75C977"
        />
        <path
            d="m182.523 137.109.269 1.904 3.222-1.904h-3.491ZM183.454 134.136l.581 2.973h-1.512l.931-2.973Z"
            fill="#75C977"
        />
        <path
            opacity={0.2}
            d="M186.014 137.109h-1.979l-.581-2.973-20.971 12.003-6.351 32.511 10.567 5.458 23.281-13.439-3.966-33.56Z"
            fill="#fff"
        />
        <path
            opacity={0.2}
            d="m166.793 145.845-3.847 31.694 3.753 6.569.094-38.263Z"
            fill="#000"
        />
        <path
            opacity={0.1}
            d="m156.132 178.65 6.814-1.111 3.753 6.569-10.567-5.458Z"
            fill="#000"
        />
        <path
            opacity={0.3}
            d="m162.483 146.139 20.971-12.003-.931 2.973h3.491l-19.222 11.359v-2.623l-4.309.294Z"
            fill="#000"
        />
        <path
            opacity={0.2}
            d="m182.523 137.109.269 1.904 3.222-1.904h-3.491Z"
            fill="#000"
        />
        <path
            d="M173.974 147.276a.348.348 0 0 1-.349-.35v-9.193a7.855 7.855 0 0 1 1.04-3.881 7.856 7.856 0 0 1 2.825-2.857 2 2 0 0 1 3.01 1.73v10.248a.35.35 0 0 1-.699 0v-10.248a1.307 1.307 0 0 0-.652-1.129 1.296 1.296 0 0 0-1.303.005 7.123 7.123 0 0 0-3.522 6.132v9.162a.356.356 0 0 1-.35.381ZM192.428 152.234a.314.314 0 0 1-.106 0 .337.337 0 0 1-.204-.171.341.341 0 0 1-.021-.266l2.542-7.925c.681-2.204 1.455-4.709 3.653-5.995a2.189 2.189 0 0 1 2.38.243 1.475 1.475 0 0 1 .624 1.58l-2.348 8.375a.355.355 0 0 1-.169.21.338.338 0 0 1-.131.04.334.334 0 0 1-.137-.013.35.35 0 0 1-.21-.165.334.334 0 0 1-.04-.13.33.33 0 0 1 .013-.136l2.348-8.374a.838.838 0 0 0-.375-.837 1.503 1.503 0 0 0-1.599-.187c-1.961 1.149-2.66 3.409-3.335 5.62l-.199.625-2.348 7.287a.347.347 0 0 1-.338.219Z"
            fill="#455A64"
        />
        <path
            d="m189.124 155.332-.093 35.639 23.281-13.439-3.959-33.56-19.229 11.36Z"
            fill="#E0E0E0"
        />
        <path
            d="M189.124 155.332v-2.623l-4.309.293-6.351 32.505 10.567 5.464.093-35.639Z"
            fill="#E0E0E0"
        />
        <path
            d="m189.125 152.709-3.847 31.693 3.753 6.569.094-38.262Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m189.125 152.709-3.847 31.693 3.753 6.569.094-38.262Z"
            fill="#000"
        />
        <path
            d="m178.464 185.507 6.814-1.105 3.753 6.569-10.567-5.464Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.1}
            d="m178.464 185.507 6.814-1.105 3.753 6.569-10.567-5.464Z"
            fill="#000"
        />
        <path
            d="m184.815 153.002 20.971-12.003-.931 2.973h3.498l-19.229 11.36v-2.623l-4.309.293Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.3}
            d="m184.815 153.002 20.971-12.003-.931 2.973h3.498l-19.229 11.36v-2.623l-4.309.293Z"
            fill="#000"
        />
        <path
            d="m204.855 143.972.275 1.898 3.223-1.898h-3.498Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="m204.855 143.972.275 1.898 3.223-1.898h-3.498Z"
            fill="#000"
        />
        <path
            d="m205.786 140.999.581 2.973h-1.512l.931-2.973Z"
            fill="#E0E0E0"
        />
        <path
            d="M196.313 154.108a.35.35 0 0 1-.35-.35v-9.162a7.837 7.837 0 0 1 3.859-6.738 2.003 2.003 0 0 1 2.005-.011c.305.175.559.428.736.732.176.305.269.651.269 1.003v10.254a.35.35 0 0 1-.349.35.354.354 0 0 1-.35-.35v-10.254a1.299 1.299 0 0 0-1.955-1.118 7.102 7.102 0 0 0-2.573 2.599 7.109 7.109 0 0 0-.943 3.533v9.162a.354.354 0 0 1-.349.35Z"
            fill="#455A64"
        />
        <path
            d="M132.321 160.065a32.417 32.417 0 0 1 5.776-16.593c2.803.999 5.881.889 8.606-.306a25.226 25.226 0 0 0-4.671 7.232 76.008 76.008 0 0 0-2.948 8.118 12.337 12.337 0 0 1-6.763 1.549Z"
            fill="#E0E0E0"
        />
        <path
            opacity={0.2}
            d="M132.321 160.065a32.417 32.417 0 0 1 5.776-16.593c2.803.999 5.881.889 8.606-.306a25.226 25.226 0 0 0-4.671 7.232 76.008 76.008 0 0 0-2.948 8.118 12.337 12.337 0 0 1-6.763 1.549Z"
            fill="#000"
        />
        <path
            d="M149.276 144.453c-2.392 1.417-5.721 1.449-8.743.712a23.454 23.454 0 0 0-8.568 14.9 7.34 7.34 0 0 0 7.55-1.299c2.03-9.292 9.761-14.313 9.761-14.313Z"
            fill="#EBEBEB"
        />
        <path
            opacity={0.1}
            d="M149.276 144.453c-2.392 1.417-5.721 1.449-8.743.712a23.454 23.454 0 0 0-8.568 14.9 7.34 7.34 0 0 0 7.55-1.299c2.03-9.292 9.761-14.313 9.761-14.313Z"
            fill="#000"
        />
        <path
            d="M149.276 145.864c-2.392 1.418-5.721 1.449-8.743.712a23.457 23.457 0 0 0-8.568 14.901 7.323 7.323 0 0 0 7.55-1.306c2.03-9.286 9.761-14.307 9.761-14.307Z"
            fill="#fff"
        />
        <path
            d="M134.144 161.196a2.588 2.588 0 0 0-1.03-2.105 21.76 21.76 0 0 1 5.676-10.092 3.843 3.843 0 0 0 3.242-1.574c1.467.431 4.433-.143 4.433-.143a1.699 1.699 0 0 0-.512 1.011c-3.166 2.898-5.714 7.382-6.426 10.473a1.955 1.955 0 0 0-.918 1.468 7.359 7.359 0 0 1-4.465.962Z"
            fill="#E6E6E6"
        />
        <path
            d="M137.504 154.451a2.013 2.013 0 0 0-.156 1.005.89.89 0 0 0 .624.762.906.906 0 0 0 .812-.218c.218-.197.403-.427.55-.681l1.086-1.699a1.672 1.672 0 0 0 .375-1.505c-.368-.836-1.318-.424-1.78 0a6.198 6.198 0 0 0-1.511 2.336Z"
            fill="#fff"
        />
        <path
            d="M100.228 103.018a6.776 6.776 0 0 0 3.31-6.364 8.18 8.18 0 0 0-4.16-6.207 9.618 9.618 0 0 0-7.493-.7c-2.18.687-4.122 2.08-6.358 2.498-1.948.393-4.047.056-5.883.812-2.304.943-3.64 3.397-4.227 5.814-.841 3.439-.54 7.057.855 10.31 1.38 3.204 4.996 7.038 8.019 8.743 3.122 3.697 8.611 1.28 10.953-1.873 2.342-3.154 4.984-13.033 4.984-13.033Z"
            fill="#F28F8F"
        />
        <path
            d="M100.228 103.018a6.776 6.776 0 0 0 3.31-6.364 8.18 8.18 0 0 0-4.16-6.207 9.618 9.618 0 0 0-7.493-.7c-2.18.687-4.122 2.08-6.358 2.498-1.948.393-4.047.056-5.883.812-2.304.943-3.64 3.397-4.227 5.814-.841 3.439-.54 7.057.855 10.31 1.38 3.204 4.996 7.038 8.019 8.743 3.122 3.697 8.611 1.28 10.953-1.873 2.342-3.154 4.984-13.033 4.984-13.033Z"
            fill="#471E1D"
        />
        <path
            d="m100.553 106.215 2.16 4.059-1.923 1.305c-.112-1.736-.131-3.647-.237-5.364Z"
            fill="#6E3938"
        />
        <path
            d="M82.392 122.046c-4.521-3.616-8.274 3.172-11.01 10.729a576.849 576.849 0 0 1-4.452 11.865 5.69 5.69 0 0 0 .768 5.483l8.062 10.717 3.597-7.782-4.465-6.769 4.547-8.306 2.953-15.937Z"
            fill="#75C977"
        />
        <path
            d="M125.757 158.042a23.507 23.507 0 0 0 7.719 2.254 14.36 14.36 0 0 0 7.856-1.361 10.616 10.616 0 0 0 5.215-6.02 2.497 2.497 0 0 0-3.079-.462 10.258 10.258 0 0 1-7.731.924 17.752 17.752 0 0 0 2.185-2.735c.313-.481.625-1.118.282-1.599a1.086 1.086 0 0 0-1.249-.331 3.69 3.69 0 0 0-1.15.737 15.61 15.61 0 0 1-6.757 3.166c-1.011 1.699-2.279 3.716-3.291 5.427ZM111.762 262.845a3.281 3.281 0 0 1-2.354.655c-2.534 0-5.056-.351-7.494-1.043a15.353 15.353 0 0 1-3.934-1.648 10.541 10.541 0 0 1-3.454-3.529c.322-1.574.51-3.172.562-4.777h6.245v3.36a32.007 32.007 0 0 0 10.336 4.546 1.67 1.67 0 0 1 .516 1.615c-.065.306-.211.59-.423.821Z"
            fill="#915B5A"
        />
        <path
            d="M94.064 259.329c.188-.675.344-1.362.488-2.049a10.55 10.55 0 0 0 3.453 3.529 15.367 15.367 0 0 0 3.934 1.648 27.445 27.445 0 0 0 7.494 1.043 3.284 3.284 0 0 0 2.355-.655 1.75 1.75 0 0 0 .418-1.762 1.677 1.677 0 0 0-.462-.693c.281.069.562.144.843.2a8.451 8.451 0 0 1 2.848.924 2.443 2.443 0 0 1 1.18 2.542c-.244.881-1.112 1.424-1.948 1.792a14.36 14.36 0 0 1-10.192.537c-2.067-.668-4.053-1.829-6.245-1.767-1.25.038-2.598.443-3.641-.231a2.784 2.784 0 0 1-1.1-2.379c.07-.915.263-1.817.575-2.679Z"
            fill="#37474F"
        />
        <path
            d="M86.264 239.126a2.365 2.365 0 0 1 2.08 1.961c.062.987-.7 1.811-1.411 2.498l-2.71 2.642a6.338 6.338 0 0 1-2.586 1.786 3.58 3.58 0 0 1-3.035-.625 4.371 4.371 0 0 1-1.206-1.461c.088-.625.163-1.249.275-1.842a4.892 4.892 0 0 1 .825-2.192c.861-1.074 2.26-1.249 3.528-1.343 1.037-.1 1.649-.699 2.423-1.293a4.842 4.842 0 0 1 1.817-.131Z"
            fill="#915B5A"
        />
        <path
            d="M77.403 245.902c.29.569.701 1.068 1.205 1.461a3.562 3.562 0 0 0 3.035.625 6.338 6.338 0 0 0 2.585-1.786l2.71-2.642c.712-.687 1.474-1.511 1.412-2.498a2.362 2.362 0 0 0-2.08-1.961 4.838 4.838 0 0 0-1.817.106l.269-.193a11.713 11.713 0 0 1 2.223-1.249 3.887 3.887 0 0 1 2.685-.356 2.885 2.885 0 0 1 1.874 2.666 5.096 5.096 0 0 1-1.162 3.179 22.45 22.45 0 0 1-2.41 2.498 30.367 30.367 0 0 0-3.085 3.497 18.812 18.812 0 0 1-2.192 2.673 4.454 4.454 0 0 1-3.123 1.318 2.642 2.642 0 0 1-2.31-1.474 4.177 4.177 0 0 1-.207-1.805c.061-1.359.19-2.713.388-4.059Z"
            fill="#37474F"
        />
        <path
            d="M105.492 166.11c1.905 24.05.475 49.104.475 49.104s-3.322 26.854-3.809 38.163c-2.71 2.679-7.92 0-7.92 0-1.485-19.646-5.413-27.209-1.13-39.437l-3.066-28.183-1.249 22.619-4.646 35.253c-2.816 2.048-6.47 0-6.47 0-1.505-17.28-5.04-25.136 0-39.181-6.032-27.977-4.028-38.612-3.235-41.435l31.05 3.097Z"
            fill="#455A64"
        />
        <path
            opacity={0.3}
            d="M79.689 173.998a14.42 14.42 0 0 0 9.46 3.534l.894 8.225-.812 15.106-1.655-21.857c-3.222-.318-6.064-2.335-7.887-5.008Z"
            fill="#000"
        />
        <path
            opacity={0.1}
            d="M82.392 122.046c-4.521-3.616-8.274 3.172-11.01 10.729a576.849 576.849 0 0 1-4.452 11.865 5.69 5.69 0 0 0 .768 5.483l8.062 10.717 3.597-7.782-4.465-6.769 4.547-8.306 2.953-15.937Z"
            fill="#000"
        />
        <path
            opacity={0.7}
            d="M82.392 122.046c-4.521-3.616-8.274 3.172-11.01 10.729a576.849 576.849 0 0 1-4.452 11.865 5.69 5.69 0 0 0 .768 5.483l8.062 10.717 3.597-7.782-4.465-6.769 4.547-8.306 2.953-15.937Z"
            fill="#fff"
        />
        <path
            d="M97.393 124.325c-4.047-1.249-15.825-3.828-18.81-1.136-2.604 2.354-4.303 10.46-.787 20.87a12.336 12.336 0 0 1-.412 9.081 53.861 53.861 0 0 0-3.56 10.235c9.461 9.642 26.13 8.15 32.474 4.047a153.755 153.755 0 0 0-1.986-23.032l-6.92-20.065Z"
            fill="#75C977"
        />
        <path
            opacity={0.4}
            d="M97.393 124.325c-4.047-1.249-15.825-3.828-18.81-1.136-2.604 2.354-4.303 10.46-.787 20.87a12.336 12.336 0 0 1-.412 9.081 53.861 53.861 0 0 0-3.56 10.235c9.461 9.642 26.13 8.15 32.474 4.047a153.755 153.755 0 0 0-1.986-23.032l-6.92-20.065Z"
            fill="#fff"
        />
        <path
            opacity={0.1}
            d="M97.393 124.325c-4.047-1.249-15.825-3.828-18.81-1.136-2.604 2.354-4.303 10.46-.787 20.87a12.336 12.336 0 0 1-.412 9.081 53.861 53.861 0 0 0-3.56 10.235c9.461 9.642 26.13 8.15 32.474 4.047a153.755 153.755 0 0 0-1.986-23.032l-6.92-20.065Z"
            fill="#fff"
        />
        <path
            d="M98.817 100.32a15.607 15.607 0 0 1 2.435 6.988c.233 2.491.269 4.997.106 7.494a4.792 4.792 0 0 1-.687 2.773c-.693.905-1.936 1.199-3.072 1.205-1.137.006-2.18 0-3.422-.038l-.25 5.165c-4.078 2.261-8.656.681-9.848-.924l.206-5.059c6.338 1.193 9.76-.98 10.36-4.908a4.443 4.443 0 0 1-3.66-.956 4.187 4.187 0 0 1-1.205-3.472c.046-.564.264-1.1.625-1.536a2.492 2.492 0 0 1 2.591-.543 3.98 3.98 0 0 1 2.049 1.817c.437.828.757 1.713.949 2.629a2.372 2.372 0 0 0 .762-2.573c-.169-.468-.506-.912-.437-1.405.068-.493.624-.899.918-1.393.21-.436.244-.938.093-1.399a5.814 5.814 0 0 0-.624-1.292 12.52 12.52 0 0 1 2.11-2.573Z"
            fill="#915B5A"
        />
        <path
            d="M97.393 124.325c7.494-3.26 8.318 3.853 12.415 11.41 2.498 4.858 5.62 9.542 5.62 9.542a56.484 56.484 0 0 0 13.795 6.37c1.624 4.284-2.142 8.487-2.142 8.487l-16.012-6.982a14.518 14.518 0 0 1-6.563-5.695c-5.752-9.368-9.986-15.987-7.113-23.132Z"
            fill="#75C977"
        />
        <path
            opacity={0.1}
            d="M97.393 124.325c7.494-3.26 8.318 3.853 12.415 11.41 2.498 4.858 5.62 9.542 5.62 9.542a56.484 56.484 0 0 0 13.795 6.37c1.624 4.284-2.142 8.487-2.142 8.487l-16.012-6.982a14.518 14.518 0 0 1-6.563-5.695c-5.752-9.368-9.986-15.987-7.113-23.132Z"
            fill="#000"
        />
        <path
            opacity={0.7}
            d="M97.393 124.325c7.494-3.26 8.318 3.853 12.415 11.41 2.498 4.858 5.62 9.542 5.62 9.542a56.484 56.484 0 0 0 13.795 6.37c1.624 4.284-2.142 8.487-2.142 8.487l-16.012-6.982a14.518 14.518 0 0 1-6.563-5.695c-5.752-9.368-9.986-15.987-7.113-23.132Z"
            fill="#fff"
        />
        <path
            d="M74.399 115.095a22.784 22.784 0 0 0 5.064-8.212 14.987 14.987 0 0 0 .113-9.542 9.686 9.686 0 0 0-3.041-4.478 6.57 6.57 0 0 0-5.14-1.392c-2.854.524-4.902 3.278-5.42 6.132-.519 2.854.212 5.789 1.142 8.543 1.156 3.435 3.81 7.663 3.354 12.49a24.653 24.653 0 0 0 3.928-3.541Z"
            fill="#F28F8F"
        />
        <path
            d="M74.399 115.095a22.784 22.784 0 0 0 5.064-8.212 14.987 14.987 0 0 0 .113-9.542 9.686 9.686 0 0 0-3.041-4.478 6.57 6.57 0 0 0-5.14-1.392c-2.854.524-4.902 3.278-5.42 6.132-.519 2.854.212 5.789 1.142 8.543 1.156 3.435 3.81 7.663 3.354 12.49a24.653 24.653 0 0 0 3.928-3.541Z"
            fill="#5C2F2F"
        />
    </svg>
);

export default SuccessIllustration;
